
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("r0CCR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7soXU = parcelRequire("7soXU");

var $8wnNT = parcelRequire("8wnNT");





var $lw3De = parcelRequire("lw3De");




/* unhandledErrorCard-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $ebrpi = parcelRequire("ebrpi");


var $3BZZG = parcelRequire("3BZZG");




const $f9a8ea2772d74085$export$86b6c8e2cf41b115 = ({ isHidden: isHidden })=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text, @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", {
        style: {
            display: isHidden ? 'none' : 'block'
        }
    }, "We couldn't load this content");


const $32d115d847b66f21$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $32d115d847b66f21$var$shouldShowText = ({ width: width, height: height })=>{
    if ($32d115d847b66f21$var$isPercentage(width) || $32d115d847b66f21$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $32d115d847b66f21$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $32d115d847b66f21$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $32d115d847b66f21$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $3BZZG.defaultImageCardDimensions).width, height: height = (0, $3BZZG.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $32d115d847b66f21$var$normalizeDimension(width, (0, $3BZZG.defaultImageCardDimensions).width),
        height: $32d115d847b66f21$var$normalizeDimension(height, (0, $3BZZG.defaultImageCardDimensions).height)
    };
};
const $32d115d847b66f21$var$wrapperStyle = null;
class $32d115d847b66f21$export$b5dd0a6175f5992c extends (0, $42omo.Component) {
    render() {
        const { dimensions: dimensions = (0, $3BZZG.defaultImageCardDimensions), onClick: onClick } = this.props;
        const convertedDimensions = $32d115d847b66f21$var$getConvertedDimension(dimensions);
        const hideText = !$32d115d847b66f21$var$shouldShowText($32d115d847b66f21$var$getConvertedDimension(dimensions));
        return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: convertedDimensions,
            onClick: onClick,
            "data-testid": "unhandled-error-card",
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1txw _4cvr1h6o _1bah1h6o _bfhki8nm _syazazsu _c71l1osq _p12f1osq _2lx21bp4 _1i7vfhey _31ku1h6o"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            label: "Error",
            color: "var(--ds-icon-warning, #E06C00)",
            spacing: "spacious"
        }), /*#__PURE__*/ $42omo.createElement((0, $f9a8ea2772d74085$export$86b6c8e2cf41b115), {
            isHidden: hideText
        }));
    }
}


const $420e30de2f2e4717$export$b5dd0a6175f5992c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32d115d847b66f21$export$b5dd0a6175f5992c), props);



var $1DWH0 = parcelRequire("1DWH0");


var $bhuzI = parcelRequire("bhuzI");

class $7313f275e0b9b090$var$WrappedMediaCardAnalyticsErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, info) {
        try {
            this.fireOperationalEvent(error, info);
        } catch (e) {}
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        const { dimensions: dimensions, children: children } = this.props;
        if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $420e30de2f2e4717$export$b5dd0a6175f5992c), {
            dimensions: dimensions,
            onClick: this.handleOnClick
        });
        return children;
    }
    constructor(props){
        super(props);
        this.fireOperationalEvent = (error, info)=>{
            const { data: data = {}, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const payload = {
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaCardRender',
                attributes: {
                    browserInfo: window?.navigator?.userAgent ? window.navigator.userAgent : 'unknown',
                    error: error,
                    info: info,
                    failReason: 'unexpected-error',
                    ...data
                }
            };
            (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
        };
        this.handleOnClick = (event)=>{
            try {
                this.props.onClick?.({
                    event: event
                });
            } catch (e) {}
        };
        this.state = {
            hasError: false
        };
    }
}
$7313f275e0b9b090$var$WrappedMediaCardAnalyticsErrorBoundary.displayName = 'MediaCardAnalyticsErrorBoundary';
const $7313f275e0b9b090$var$packageName = "platform-pkg";
const $7313f275e0b9b090$var$packageVersion = "0.0.0-use.local";
// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
const $7313f275e0b9b090$var$MediaCardAnalyticsErrorBoundary = (0, $lw3De.withMediaAnalyticsContext)({
    packageVersion: $7313f275e0b9b090$var$packageVersion,
    packageName: $7313f275e0b9b090$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $1DWH0.default)()($7313f275e0b9b090$var$WrappedMediaCardAnalyticsErrorBoundary));
var $7313f275e0b9b090$export$2e2bcd8739ae039 = $7313f275e0b9b090$var$MediaCardAnalyticsErrorBoundary;



var $e63NX = parcelRequire("e63NX");








var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $inPa6 = parcelRequire("inPa6");


var $eGqQQ = parcelRequire("eGqQQ");


var $fCrf0 = parcelRequire("fCrf0");


var $7NoXb = parcelRequire("7NoXb");





var $jTxSS = parcelRequire("jTxSS");


var $ihjDz = parcelRequire("ihjDz");

const $e742eeee478b46f8$export$48da330df5248c4c = ()=>{
    return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, '');
};


/**
 * Entry Point: @atlaskit/media-card/types
 * tsconfig.entry-points.json
 */ const $31b9f913d9ecc724$export$dea79d05143ccf4 = (preview)=>$31b9f913d9ecc724$export$36aae1afbc0a9661(preview) || $31b9f913d9ecc724$export$48a298744248dfdd(preview) || $31b9f913d9ecc724$export$f366c2c8a792cce6(preview);
const $31b9f913d9ecc724$export$48a298744248dfdd = (preview)=>{
    const ssrClientSources = [
        'ssr-server',
        'cache-ssr-server'
    ];
    return ssrClientSources.includes(preview.source);
};
const $31b9f913d9ecc724$export$36aae1afbc0a9661 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'cache-ssr-client'
    ];
    return ssrClientSources.includes(preview.source);
};
const $31b9f913d9ecc724$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
var $31b9f913d9ecc724$export$2abd8762d023dc4c = /*#__PURE__*/ function(MediaCardCursor) {
    MediaCardCursor["Action"] = "pointer";
    MediaCardCursor["NotReady"] = "wait";
    return MediaCardCursor;
}({});


const $05cb2a5058fcf886$export$c364ca3a4cf16be0 = (useInlinePlayer, useMediaViewer, isErrorStatus, hasCardPreview, mediaType)=>{
    // If error status or no action is requested = NoAction
    if (isErrorStatus || !useInlinePlayer && !useMediaViewer) return;
    if (!mediaType && (useInlinePlayer || useInlinePlayer && useMediaViewer)) return (0, $31b9f913d9ecc724$export$2abd8762d023dc4c).NotReady;
    else if (mediaType === 'video' && hasCardPreview && useInlinePlayer) return (0, $31b9f913d9ecc724$export$2abd8762d023dc4c).Action;
    if (useMediaViewer) return (0, $31b9f913d9ecc724$export$2abd8762d023dc4c).Action;
    return;
};






var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");

var $28cxD = parcelRequire("28cxD");


var $8QL6C = parcelRequire("8QL6C");


var $chIYi = parcelRequire("chIYi");








var $dPp8R = parcelRequire("dPp8R");


var $4u5NT = parcelRequire("4u5NT");

const $0a91ab5f84deabce$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $0a91ab5f84deabce$var$printParams = (args)=>args.map((arg)=>$0a91ab5f84deabce$var$printParam(arg)).join(',');
const $0a91ab5f84deabce$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$0a91ab5f84deabce$var$printParams(args)});`;
const $0a91ab5f84deabce$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;


const $5e98d8d1722a5532$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $5e98d8d1722a5532$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $5e98d8d1722a5532$export$7aeb4eab53a57df7 = 'performanceEntries';
function $5e98d8d1722a5532$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $5e98d8d1722a5532$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $5e98d8d1722a5532$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $5e98d8d1722a5532$var$dashed = (param)=>param ? `-${param}` : '';
const $5e98d8d1722a5532$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$5e98d8d1722a5532$var$dashed(collectionName)}${$5e98d8d1722a5532$var$dashed(occurrenceKey)}`;
const $5e98d8d1722a5532$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $5e98d8d1722a5532$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $5e98d8d1722a5532$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $0a91ab5f84deabce$export$3742967cc82ac85a)($5e98d8d1722a5532$export$4310981e0aa4ce67, $5e98d8d1722a5532$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $0a91ab5f84deabce$export$8b902fb69a2f17c1)([
        $5e98d8d1722a5532$export$ede93d4564eaa8da.toString(),
        $5e98d8d1722a5532$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $5e98d8d1722a5532$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $5e98d8d1722a5532$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });


const $f7feab67f02696f1$var$packageName = "platform-pkg";
const $f7feab67f02696f1$var$packageVersion = "0.0.0-use.local";
const $f7feab67f02696f1$var$SAMPLE_RATE = 0.05;
const $f7feab67f02696f1$export$b21c64f4f93d10f4 = ()=>Math.random() < $f7feab67f02696f1$var$SAMPLE_RATE;
/**
 * Gets the UFO interaction start time.
 * For page_load: returns 0 (relative to page navigation)
 * For SPA transitions: returns performance.now() when transition started
 */ const $f7feab67f02696f1$var$getInteractionStartTime = ()=>{
    const interaction = (0, $4u5NT.getActiveInteraction)();
    return interaction?.start ?? 0;
};
/**
 * Finds a performance resource timing entry by matching a full URI.
 * Searches from the end (most recent) to find the latest matching entry.
 */ const $f7feab67f02696f1$var$findPerformanceEntryByName = (name)=>{
    if (typeof performance === 'undefined' || !performance.getEntriesByType) return undefined;
    // For data URIs (base64), there won't be a performance entry
    if (name.startsWith('data:')) return undefined;
    const entries = performance.getEntriesByType('resource');
    const ssrPerformanceEntries = (0, $5e98d8d1722a5532$export$96a3cfb3a41e9bb2)().performanceEntries ?? [];
    return [
        ...ssrPerformanceEntries,
        ...entries
    ].find((entry)=>name.includes(entry.name));
};
/**
 * Creates timing configuration for the UFO experience based on the performance entry.
 * These timings will be calculated by UFO using the marks we add.
 */ const $f7feab67f02696f1$var$createTimingsConfig = (prefix)=>[
        {
            key: `${prefix}:resourceTiming`,
            startMark: `${prefix}:resourceTiming:start`,
            endMark: `${prefix}:resourceTiming:end`
        },
        {
            key: `${prefix}:dnsLookup`,
            startMark: `${prefix}:dnsLookup:start`,
            endMark: `${prefix}:dnsLookup:end`
        },
        {
            key: `${prefix}:tcpHandshake`,
            startMark: `${prefix}:tcpHandshake:start`,
            endMark: `${prefix}:tcpHandshake:end`
        },
        {
            key: `${prefix}:tlsNegotiation`,
            startMark: `${prefix}:tlsNegotiation:start`,
            endMark: `${prefix}:tlsNegotiation:end`
        },
        {
            key: `${prefix}:ttfb`,
            startMark: `${prefix}:ttfb:start`,
            endMark: `${prefix}:ttfb:end`
        },
        {
            key: `${prefix}:contentDownload`,
            startMark: `${prefix}:contentDownload:start`,
            endMark: `${prefix}:contentDownload:end`
        },
        {
            key: `${prefix}:redirect`,
            startMark: `${prefix}:redirect:start`,
            endMark: `${prefix}:redirect:end`
        },
        {
            key: `${prefix}:fetchTime`,
            startMark: `${prefix}:fetchTime:start`,
            endMark: `${prefix}:fetchTime:end`
        }
    ];
/**
 * Creates resource timing metadata from a performance entry.
 * Only includes non-timing information (sizes, cache status, protocol, CDN info).
 * Timing durations are captured via marks which feed into the timings config.
 */ const $f7feab67f02696f1$var$createResourceTimingMetadata = (entry)=>{
    return {
        // Size information
        resourceTransferSize: entry.transferSize,
        resourceDecodedBodySize: entry.decodedBodySize,
        // Request info
        resourceInitiatorType: entry.initiatorType,
        resourceNextHopProtocol: entry.nextHopProtocol,
        // Cache status
        resourceBrowserCacheHit: entry.transferSize === 0,
        // Server timing (CDN metrics)
        resourceCdnCacheHit: entry.serverTiming?.some(({ name: name })=>name === 'cdn-cache-hit') ?? false,
        resourceCdnDownstreamFBL: entry.serverTiming?.find(({ name: name })=>name === 'cdn-downstream-fbl')?.duration,
        resourceCdnUpstreamFBL: entry.serverTiming?.find(({ name: name })=>name === 'cdn-upstream-fbl')?.duration
    };
};
/**
 * Adds timing marks from a performance resource timing entry to the UFO experience.
 */ const $f7feab67f02696f1$var$addResourceTimingMarks = (experience, entry, interactionStartTime, prefix)=>{
    const addMark = (name, start, end)=>{
        const relativeStart = start - interactionStartTime;
        const relativeEnd = end - interactionStartTime;
        if (relativeEnd > relativeStart && relativeStart >= 0) {
            experience.mark(`${prefix}:${name}:start`, relativeStart);
            experience.mark(`${prefix}:${name}:end`, relativeEnd);
        }
    };
    // Overall resource timing
    addMark('resourceTiming', entry.startTime, entry.responseEnd);
    // DNS lookup
    addMark('dnsLookup', entry.domainLookupStart, entry.domainLookupEnd);
    // TCP handshake
    addMark('tcpHandshake', entry.connectStart, entry.connectEnd);
    // TLS negotiation (only for HTTPS)
    if (entry.secureConnectionStart > 0) addMark('tlsNegotiation', entry.secureConnectionStart, entry.requestStart);
    // Request to first byte (TTFB)
    addMark('ttfb', entry.requestStart, entry.responseStart);
    // Content download
    addMark('contentDownload', entry.responseStart, entry.responseEnd);
    // Redirect time (if any)
    if (entry.redirectStart > 0 && entry.redirectEnd > 0) addMark('redirect', entry.redirectStart, entry.redirectEnd);
    // Total fetch time (without redirect) - from fetchStart to responseEnd
    addMark('fetchTime', entry.fetchStart, entry.responseEnd);
};
const $f7feab67f02696f1$var$sanitiseFileAttributes = (fileAttributes)=>{
    let sanitisedFileId = 'INVALID_FILE_ID';
    if (fileAttributes.fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($chIYi)))(fileAttributes.fileId)) sanitisedFileId = fileAttributes.fileId;
    return {
        ...fileAttributes,
        fileId: sanitisedFileId
    };
};
const $f7feab67f02696f1$var$getBasePayloadAttributes = ()=>({
        packageName: $f7feab67f02696f1$var$packageName,
        packageVersion: $f7feab67f02696f1$var$packageVersion,
        mediaEnvironment: (0, $dPp8R.getMediaEnvironment)(),
        mediaRegion: (0, $dPp8R.getMediaRegion)()
    });
/**
 * Creates a new UFO experience instance with the given configuration.
 */ const $f7feab67f02696f1$var$createExperience = (instanceId, timings = [])=>{
    return new (0, $4SCyD.UFOExperience)('media-card-render', {
        platform: {
            component: 'media-card'
        },
        type: (0, $iqaft.ExperienceTypes).Experience,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult,
        featureFlags: (0, $8QL6C.getFeatureFlagKeysAllProducts)(),
        timings: timings
    }, instanceId);
};
const $f7feab67f02696f1$export$a42e845f664e6373 = ({ instanceId: instanceId, enabled: enabled })=>{
    // Store the start time when start() is called - experience creation is deferred to complete()
    const startTimeRef = (0, $42omo.useRef)(undefined);
    const hasStartedRef = (0, $42omo.useRef)(false);
    // Store the experience so abort() can use it after complete() has run
    const experienceRef = (0, $42omo.useRef)(null);
    // Reset refs when instanceId changes (new card instance)
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Note: Don't clear experienceRef here as abort() might still need it
            // The component's cleanup calls abort() which handles final state
            hasStartedRef.current = false;
            startTimeRef.current = undefined;
        };
    }, [
        instanceId
    ]);
    const start = (0, $42omo.useCallback)((options)=>{
        if (!enabled) return;
        // Store the start time - experience will be created in complete()
        // This allows us to have the correct timings config when creating the experience
        hasStartedRef.current = true;
        startTimeRef.current = options?.useInteractionTime ? $f7feab67f02696f1$var$getInteractionStartTime() : performance.now();
    }, [
        enabled
    ]);
    const complete = (0, $42omo.useCallback)((status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), ssrPreviewInfo)=>{
        // Only complete for terminal statuses - ignore intermediate statuses like 'loading-preview'
        if (![
            'complete',
            'error',
            'failed-processing'
        ].includes(status)) return;
        if (!enabled || !hasStartedRef.current) return;
        const interactionStartTime = $f7feab67f02696f1$var$getInteractionStartTime();
        // Determine timings config based on SSR status
        let timingsConfig = [];
        let resourceTimingEntry;
        if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
            resourceTimingEntry = $f7feab67f02696f1$var$findPerformanceEntryByName(ssrPreviewInfo.srcset ?? ssrPreviewInfo.dataUri);
            if (resourceTimingEntry) timingsConfig = $f7feab67f02696f1$var$createTimingsConfig('ssr');
        }
        // Create the experience with the correct timings config
        const experience = $f7feab67f02696f1$var$createExperience(instanceId, timingsConfig);
        experienceRef.current = experience;
        experience.start(startTimeRef.current);
        let endTime = performance.now();
        // Add timing marks and metadata based on strategy
        if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
            if (resourceTimingEntry) {
                endTime = resourceTimingEntry.responseEnd;
                $f7feab67f02696f1$var$addResourceTimingMarks(experience, resourceTimingEntry, interactionStartTime, 'ssr');
                experience.addMetadata({
                    ...$f7feab67f02696f1$var$createResourceTimingMetadata(resourceTimingEntry),
                    timingStrategy: 'ssr-resource-timing'
                });
            } else experience.addMetadata({
                timingStrategy: 'ssr-no-entry-found'
            });
        } else if (ssrPreviewInfo?.wasSSRAttempted) {
            // Strategy 2: SSR was attempted but failed - use interaction start time
            experience.addMetadata({
                timingStrategy: 'ssr-failed',
                interactionStartTime: interactionStartTime
            });
            experience.mark('interactionStart', 0);
        } else // Strategy 3: No SSR - CSR mount-based behavior
        experience.addMetadata({
            timingStrategy: 'csr-mount-based'
        });
        // Complete the experience with appropriate state
        const sanitisedFileAttributes = $f7feab67f02696f1$var$sanitiseFileAttributes(fileAttributes);
        switch(status){
            case 'complete':
                experience.addMetadata({
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                });
                experience.transition((0, $28cxD.UFOExperienceState).SUCCEEDED, endTime);
                break;
            case 'failed-processing':
                experience.failure({
                    metadata: {
                        fileAttributes: sanitisedFileAttributes,
                        ssrReliability: ssrReliability,
                        fileStateFlags: fileStateFlags,
                        failReason: 'failed-processing',
                        ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                    }
                });
                break;
            case 'error':
                experience.failure({
                    metadata: {
                        fileAttributes: sanitisedFileAttributes,
                        ssrReliability: ssrReliability,
                        fileStateFlags: fileStateFlags,
                        ...(0, $bhuzI.extractErrorInfo)(error),
                        request: (0, $bhuzI.getRenderErrorRequestMetadata)(error),
                        ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                    }
                });
                break;
        }
        // Reset state after completion
        hasStartedRef.current = false;
        startTimeRef.current = undefined;
    }, [
        enabled,
        instanceId
    ]);
    const abort = (0, $42omo.useCallback)((properties)=>{
        if (!enabled) return;
        // Use existing experience if available (created by complete()),
        // otherwise create new one if experience was started but not completed
        let experience = experienceRef.current;
        if (!experience) {
            if (!hasStartedRef.current) return;
            experience = $f7feab67f02696f1$var$createExperience(instanceId);
            experienceRef.current = experience;
            experience.start(startTimeRef.current);
        }
        const metadata = {
            ...$f7feab67f02696f1$var$getBasePayloadAttributes()
        };
        if (properties?.fileAttributes) metadata.fileAttributes = $f7feab67f02696f1$var$sanitiseFileAttributes(properties.fileAttributes);
        if (properties?.fileStateFlags) metadata.fileStateFlags = properties.fileStateFlags;
        if (properties?.ssrReliability) metadata.ssrReliability = properties.ssrReliability;
        // UFO will ignore abort if experience is already in final state
        experience.abort({
            metadata: metadata
        });
        // Reset state after abort
        hasStartedRef.current = false;
        startTimeRef.current = undefined;
    }, [
        enabled,
        instanceId
    ]);
    return (0, $42omo.useMemo)(()=>({
            start: start,
            complete: complete,
            abort: abort
        }), [
        start,
        complete,
        abort
    ]);
};
// ============================================================================
// Legacy exports for backwards compatibility
// These will be removed once all consumers are migrated to the hook
// ============================================================================
let $f7feab67f02696f1$var$concurrentExperience;
const $f7feab67f02696f1$var$getExperience = (id)=>{
    if (!$f7feab67f02696f1$var$concurrentExperience) {
        const inlineExperience = {
            platform: {
                component: 'media-card'
            },
            type: (0, $iqaft.ExperienceTypes).Experience,
            performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $8QL6C.getFeatureFlagKeysAllProducts)()
        };
        $f7feab67f02696f1$var$concurrentExperience = new (0, $9801n.ConcurrentExperience)('media-card-render', inlineExperience);
    }
    return $f7feab67f02696f1$var$concurrentExperience.getInstance(id);
};
const $f7feab67f02696f1$export$5e9287b6a10f8075 = (id, startTime)=>{
    $f7feab67f02696f1$var$getExperience(id).start(startTime);
};
const $f7feab67f02696f1$export$9d46b54f7b0bb11a = (id, status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), ssrPreviewInfo)=>{
    // Only complete for terminal statuses - ignore intermediate statuses like 'loading-preview'
    if (![
        'complete',
        'error',
        'failed-processing'
    ].includes(status)) return;
    const experience = $f7feab67f02696f1$var$getExperience(id);
    const interactionStartTime = $f7feab67f02696f1$var$getInteractionStartTime();
    // Determine timing strategy based on SSR status
    if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
        const entry = $f7feab67f02696f1$var$findPerformanceEntryByName(ssrPreviewInfo.srcset ?? ssrPreviewInfo.dataUri);
        if (entry) {
            $f7feab67f02696f1$var$addResourceTimingMarks(experience, entry, interactionStartTime, 'ssr');
            experience.addMetadata({
                ...$f7feab67f02696f1$var$createResourceTimingMetadata(entry),
                timingStrategy: 'ssr-resource-timing'
            });
        } else experience.addMetadata({
            timingStrategy: 'ssr-no-entry-found'
        });
    } else if (ssrPreviewInfo?.wasSSRAttempted) {
        experience.addMetadata({
            timingStrategy: 'ssr-failed',
            interactionStartTime: interactionStartTime
        });
        experience.mark('interactionStart', 0);
    } else experience.addMetadata({
        timingStrategy: 'csr-mount-based'
    });
    const sanitisedFileAttributes = $f7feab67f02696f1$var$sanitiseFileAttributes(fileAttributes);
    switch(status){
        case 'complete':
            experience.success({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                }
            });
            break;
        case 'failed-processing':
            experience.failure({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    failReason: 'failed-processing',
                    ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                }
            });
            break;
        case 'error':
            experience.failure({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...(0, $bhuzI.extractErrorInfo)(error),
                    request: (0, $bhuzI.getRenderErrorRequestMetadata)(error),
                    ...$f7feab67f02696f1$var$getBasePayloadAttributes()
                }
            });
            break;
    }
};
const $f7feab67f02696f1$export$b1021040eb94cdca = (id, properties)=>{
    const metadata = {
        ...$f7feab67f02696f1$var$getBasePayloadAttributes()
    };
    if (properties?.fileAttributes) metadata.fileAttributes = $f7feab67f02696f1$var$sanitiseFileAttributes(properties.fileAttributes);
    if (properties?.fileStateFlags) metadata.fileStateFlags = properties.fileStateFlags;
    if (properties?.ssrReliability) metadata.ssrReliability = properties.ssrReliability;
    $f7feab67f02696f1$var$getExperience(id).abort({
        metadata: metadata
    });
};





function $b757c0672a5eef1f$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}








function $93fac9ac27817247$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}









var $dh538 = parcelRequire("dh538");

// Sampling rate for mediaCardRender success events (10%)
const $704b605b60b0a22f$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE = 0.1;
const $704b605b60b0a22f$export$a1fb57756f0de62b = (createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext, processingFailReason)=>{
    const fireEvent = (payload)=>(0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
    switch(status){
        case 'complete':
            // Sample success events at 10% when feature flag is enabled - failures are never sampled
            // If flag is disabled, all success events fire (no sampling)
            const isSamplingEnabled = (0, $dh538.fg)('enable_sampling_mediacardrender_succeeded');
            if (!isSamplingEnabled || Math.random() < $704b605b60b0a22f$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE) fireEvent((0, $bhuzI.getRenderSucceededEventPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, isSamplingEnabled ? $704b605b60b0a22f$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE : undefined));
            break;
        case 'failed-processing':
            // Always emit failed events (no sampling)
            fireEvent((0, $bhuzI.getRenderFailedFileStatusPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, processingFailReason));
            break;
        case 'error':
            // Always emit error events (no sampling)
            fireEvent((0, $bhuzI.getRenderErrorEventPayload)(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext));
            break;
    }
};
const $704b605b60b0a22f$export$6505e60579e04cbd = (createAnalyticsEvent, cardStatus, fileAttributes, ssrReliability, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const errorPayload = (0, $bhuzI.getErrorEventPayload)(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext);
    (0, $bhuzI.fireMediaCardEvent)(errorPayload, createAnalyticsEvent);
};
const $704b605b60b0a22f$export$8f39639231268ced = (createAnalyticsEvent, fileAttributes, traceContext, metadataTraceContext)=>{
    const payload = (0, $bhuzI.getDownloadSucceededEventPayload)(fileAttributes, traceContext, metadataTraceContext);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $704b605b60b0a22f$export$f0368e92a624442a = (createAnalyticsEvent, fileAttributes, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const payload = (0, $bhuzI.getDownloadFailedEventPayload)(fileAttributes, error, traceContext, metadataTraceContext);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};












var $cneVc = parcelRequire("cneVc");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $iP9n7 = parcelRequire("iP9n7");


var $31QJ7 = parcelRequire("31QJ7");











var $aWYXa = parcelRequire("aWYXa");

function $e51b4f7915b81795$export$31853d267a6d0b0b(resizeMode) {
    return {
        crop: resizeMode === 'crop',
        stretch: resizeMode === 'stretchy-fit'
    };
}



const $50e4d3749f50fc3a$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt, resizeMode: resizeMode, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay })=>{
    const onDisplayImageRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(onDisplayImage);
    (0, $42omo.useEffect)(()=>{
        // TODO: trigger accordingly with the succeeded event. This could be a breaking change
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const onLoad = ()=>{
        onImageLoad && cardPreview && onImageLoad(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aWYXa.MediaImage), {
        dataURI: cardPreview?.dataURI,
        alt: alt,
        previewOrientation: cardPreview?.orientation,
        onImageLoad: onLoad,
        onImageError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        forceSyncDisplay: forceSyncDisplay,
        ...(0, $e51b4f7915b81795$export$31853d267a6d0b0b)(resizeMode)
    });
};


/* imageRendererV2.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $938ba4cf2afc4c26$var$roundedRatio = (ratio)=>{
    return Math.round(ratio * 100) / 100;
};
const $938ba4cf2afc4c26$var$DEFAULT_CROP_DIMENSIONS = {
    maxWidth: '100%'
};
const $938ba4cf2afc4c26$var$DEFAULT_STRETCHY_FIT_DIMENSIONS = {
    width: '100%',
    maxHeight: '100%'
};
const $938ba4cf2afc4c26$export$da67e68efa508cf6 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    if ((0, $dh538.fg)('media-perf-uplift-mutation-fix')) {
        const isSameRatio = (0, $dh538.fg)('media-perf-ratio-calc-fix') ? Math.abs(imgWidth / parentWidth - imgHeight / parentHeight) < 0.1 : $938ba4cf2afc4c26$var$roundedRatio(imgWidth / parentWidth) === $938ba4cf2afc4c26$var$roundedRatio(imgHeight / parentHeight);
        if (isSameRatio) {
            if (resizeMode === 'stretchy-fit') return $938ba4cf2afc4c26$var$DEFAULT_STRETCHY_FIT_DIMENSIONS;
            return $938ba4cf2afc4c26$var$DEFAULT_CROP_DIMENSIONS;
        }
    }
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};
const $938ba4cf2afc4c26$export$6e6f68a4ed3ceffe = (resizeMode)=>{
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `100%`,
        maxHeight: `100%`
    };
    if (resizeMode === 'stretchy-fit') // assume the image is landscape
    return $938ba4cf2afc4c26$var$DEFAULT_STRETCHY_FIT_DIMENSIONS;
    // resizeMode === 'crop'
    // assume the image is landscape
    return (0, $dh538.fg)('media-perf-uplift-mutation-fix') ? $938ba4cf2afc4c26$var$DEFAULT_CROP_DIMENSIONS : {
        width: '100%'
    };
};



/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $dab5c8a7d70eb9fe$var$wrapperStyles = null;
const $dab5c8a7d70eb9fe$export$e2adeb4aa5a3be1d = ({ children: children })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "ImageRendererWrapper",
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ])
    }, children);









var $cbc8g = parcelRequire("cbc8g");


var $9x4nt = parcelRequire("9x4nt");

const $f48d6082771fffe1$var$baseStyles = null;
const $f48d6082771fffe1$var$backgroundStyles = null;
const $f48d6082771fffe1$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt = '', resizeMode: resizeMode = 'crop', onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, identifier: identifier, wrapperRef: wrapperRef, useWhiteBackground: useWhiteBackground, testId: testId })=>{
    const onDisplayImageRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(onDisplayImage);
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    (0, $42omo.useEffect)(()=>{
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const [didRender, setDidRender] = (0, $42omo.useState)(false);
    const [resolvedDimensions, setResolvedDimensions] = (0, $42omo.useState)((0, $938ba4cf2afc4c26$export$6e6f68a4ed3ceffe)(resizeMode));
    (0, $42omo.useLayoutEffect)(()=>{
        if (!didRender && (0, $dh538.fg)('platfrom_close_blindspot_for_img')) return ufoContext?.hold('img-loading');
    }, [
        didRender,
        ufoContext
    ]);
    const imgRef = (0, $42omo.useRef)(null);
    const onLoad = (evt)=>{
        wrapperRef.current && setResolvedDimensions((0, $938ba4cf2afc4c26$export$da67e68efa508cf6)(evt.currentTarget, wrapperRef.current, resizeMode));
        setDidRender(true);
        cardPreview && onImageLoad?.(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    (0, $42omo.useEffect)(()=>{
        if (imgRef.current && wrapperRef.current && imgRef.current) setResolvedDimensions((0, $938ba4cf2afc4c26$export$da67e68efa508cf6)(imgRef.current, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    return cardPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dab5c8a7d70eb9fe$export$e2adeb4aa5a3be1d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        ref: (ref)=>{
            if ((0, $dh538.fg)('media-perf-uplift-mutation-fix')) {
                if (!imgRef.current && ref?.complete) {
                    // we need to set the imgRef before calling onLoad to avoid recursive rendering
                    imgRef.current = ref;
                    onLoad({
                        currentTarget: ref
                    });
                }
            } else imgRef.current = ref;
        },
        "data-testid": testId,
        "data-fileid": (0, $e63NX.isFileIdentifier)(identifier) ? identifier.id : null,
        "data-filecollection": (0, $e63NX.isFileIdentifier)(identifier) ? identifier.collectionName : null,
        "data-resizemode": resizeMode,
        "data-source": cardPreview.source,
        src: cardPreview.dataURI,
        srcSet: cardPreview.srcSet,
        alt: alt,
        onLoad: onLoad,
        onError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        style: {
            visibility: didRender || forceSyncDisplay ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...resolvedDimensions
        },
        className: (0, $gMc0m.default)([
            "_5ral1f51",
            useWhiteBackground && "_bfhku67f"
        ])
    })) : null;
};





const $484e134ecbfafbbc$export$a8e6523ab063becd = (props)=>{
    return (0, $dh538.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f48d6082771fffe1$export$a8e6523ab063becd), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50e4d3749f50fc3a$export$a8e6523ab063becd), props);
};









var $9Q2dU = parcelRequire("9Q2dU");




/* truncateText-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $33436a98e576e313$export$76bc6de55c805afb = (text, startFixedChars, endFixedChars)=>{
    const minAllowedLength = endFixedChars + startFixedChars;
    if (text.length <= minAllowedLength) // if no truncation return same value for left and right
    return {
        left: text,
        right: text
    };
    const splitAt = text.length - endFixedChars;
    const left = text.substr(0, splitAt);
    const right = text.substr(splitAt);
    return {
        left: left,
        right: right
    };
};
const $33436a98e576e313$var$truncateCommonStyles = null;
const $33436a98e576e313$var$truncateLeftStyles = null;
const $33436a98e576e313$export$79559b74b73162c4 = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            maxWidth: `calc(
		100% -
			${$33436a98e576e313$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em
	)`,
            minWidth: $33436a98e576e313$var$fontFaceScaleFactor(fontSizePX) * startFixedChars
        },
        "data-testid": "truncate-left",
        ...props,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_1bto1l2s"
        ])
    }, children);
const $33436a98e576e313$var$truncateRightStyles = null;
const $33436a98e576e313$export$59f20ffe54d328be = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            maxWidth: `calc(
				100% -
					${({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$33436a98e576e313$var$fontFaceScaleFactor(fontSizePX) * startFixedChars}
			)`
        },
        "data-testid": "truncate-right",
        ...props,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_kqswh2mm"
        ])
    }, children);
const $33436a98e576e313$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $33436a98e576e313$var$placeholder = ' ';
const $33436a98e576e313$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = $33436a98e576e313$export$76bc6de55c805afb(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33436a98e576e313$export$79559b74b73162c4, {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, leftStr), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33436a98e576e313$export$59f20ffe54d328be, {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, leftStr === rightStr ? $33436a98e576e313$var$placeholder : rightStr));
};


const $440441dc3c55dd0a$export$cf4c160b6f7612df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33436a98e576e313$export$cf4c160b6f7612df), props);
const $440441dc3c55dd0a$export$79559b74b73162c4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33436a98e576e313$export$79559b74b73162c4), props);
const $440441dc3c55dd0a$export$59f20ffe54d328be = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33436a98e576e313$export$59f20ffe54d328be), props);



var $cXJTn = parcelRequire("cXJTn");







/* titleBoxComponents-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6fnsQ = parcelRequire("6fnsQ");


var $kaSe5 = parcelRequire("kaSe5");

const $4418aacd8fd17f3c$var$smallLineHeight = 14;
const $4418aacd8fd17f3c$var$smallVerticalPadding = 4;
const $4418aacd8fd17f3c$var$smallHorizontalPadding = 8;
const $4418aacd8fd17f3c$var$largeLineHeight = 22;
const $4418aacd8fd17f3c$var$largeVerticalPadding = 8;
const $4418aacd8fd17f3c$var$largeHorizontalPadding = 12;
const $4418aacd8fd17f3c$var$responsiveStyleMap = {
    small: "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _4t3i14no",
    large: "_ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _4t3i1wqb"
};
const $4418aacd8fd17f3c$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $4418aacd8fd17f3c$var$titleBoxWrapperStyles = null;
const $4418aacd8fd17f3c$export$213c428ce4ec143c = (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    const color = titleBoxBgColor && (0, $kaSe5.rgba)($4418aacd8fd17f3c$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : (0, $6fnsQ.N0), 1);
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: color,
            display: hidden ? 'none' : undefined
        },
        className: (0, $gMc0m.default)([
            "_kqswstnw _94n5idpf _1bsb1osq _bfhkvuon _syazi7uo _80om1kw7 _lcxvglyw _1e0c1txw _2lx21bp4 _1bah1h6o",
            $4418aacd8fd17f3c$var$responsiveStyleMap[breakpoint]
        ])
    }, props.children);
};
$4418aacd8fd17f3c$export$213c428ce4ec143c.displayName = 'TitleBoxWrapper';
const $4418aacd8fd17f3c$var$infoStyles = null;
const $4418aacd8fd17f3c$var$iconOverlapStyle = null;
const $4418aacd8fd17f3c$var$titleBoxHeaderStyles = null;
const $4418aacd8fd17f3c$export$43970d913b015380 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        className: (0, $gMc0m.default)([
            "_k48p1pd9",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ])
    }, props.children);
};
$4418aacd8fd17f3c$export$43970d913b015380.displayName = 'FailedTitleBoxHeader';
const $4418aacd8fd17f3c$var$titleBoxFooterStyles = null;
const $4418aacd8fd17f3c$export$1004da4fc5583975 = (props)=>{
    const { hasIconOverlap: hasIconOverlap, suppressHydrationWarning: suppressHydrationWarning } = props;
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "titleBoxFooter",
        suppressHydrationWarning: suppressHydrationWarning,
        "data-testid": "title-box-footer",
        className: (0, $gMc0m.default)([
            "_1bto1l2s",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ])
    }, props.children);
};
$4418aacd8fd17f3c$export$1004da4fc5583975.displayName = 'TitleBoxFooter';
const $4418aacd8fd17f3c$var$titleBoxIconStyles = null;
const $4418aacd8fd17f3c$export$70e996312f72d22d = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi21b66 _94n51b66"
        ])
    }, props.children);
};
const $4418aacd8fd17f3c$var$errorMessageWrapperStyles = null;
const $4418aacd8fd17f3c$export$9e874bb1adc98a55 = (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpv77o _1e0c1txw _4cvr1h6o _1bah1y6m _bozgv77o"
        ])
    }, props.children);
};


const $a360eb37c4d601e8$export$213c428ce4ec143c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4418aacd8fd17f3c$export$213c428ce4ec143c), props);
const $a360eb37c4d601e8$export$43970d913b015380 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4418aacd8fd17f3c$export$43970d913b015380), props);
const $a360eb37c4d601e8$export$1004da4fc5583975 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4418aacd8fd17f3c$export$1004da4fc5583975), props);
const $a360eb37c4d601e8$export$70e996312f72d22d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4418aacd8fd17f3c$export$70e996312f72d22d), props);
const $a360eb37c4d601e8$export$9e874bb1adc98a55 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4418aacd8fd17f3c$export$9e874bb1adc98a55), props);


const $23621622fab39a6b$var$placeholderText = ' ';
const $23621622fab39a6b$var$isValidTimestamp = (timeStamp)=>new Date(timeStamp).getTime() > 0;
const $23621622fab39a6b$export$e3ce443f3b72c291 = (0, $gmMgo.default)(({ name: name, createdAt: createdAt, breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, hidden: _hidden, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$213c428ce4ec143c), {
        breakpoint: breakpoint,
        titleBoxBgColor: titleBoxBgColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$43970d913b015380), {
        hasIconOverlap: !!titleBoxIcon && !createdAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $440441dc3c55dd0a$export$cf4c160b6f7612df), {
        text: name ?? $23621622fab39a6b$var$placeholderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$1004da4fc5583975), {
        hasIconOverlap: !!titleBoxIcon,
        // Suppressing it here because of a timezone mismatch in the createdAt text
        // that can cause a late mutation in the attachments strip view
        suppressHydrationWarning: (0, $dh538.fg)('jfp-magma-fix-attachments-hydration-error') ? true : false
    }, createdAt !== undefined && $23621622fab39a6b$var$isValidTimestamp(createdAt) ? (0, $cXJTn.formatDate)(createdAt, intl?.locale ?? 'en') : $23621622fab39a6b$var$placeholderText), titleBoxIcon === 'LockFilledIcon' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$70e996312f72d22d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), {
    enforceContext: false
});


/* failedTitleBox.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");








const $64661f5936e4ae88$var$errorMessageWrapperStyles = null;
const $64661f5936e4ae88$export$9b3b0baef32e2e39 = ({ breakpoint: breakpoint, customMessage: customMessage = (0, $31QJ7.messages).failed_to_load })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$213c428ce4ec143c), {
        breakpoint: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a360eb37c4d601e8$export$9e874bb1adc98a55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: 'Warning',
        color: "var(--ds-text-danger, #AE2E24)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_s7n4nkob _18u01b66 _2hwx1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), customMessage))));
};



var $4nZRJ = parcelRequire("4nZRJ");





var $hLeLq = parcelRequire("hLeLq");




/* playButtonWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cfgsK = parcelRequire("cfgsK");

const $795b5c887ec9edde$var$playButtonWrapperStyles = null;
const $795b5c887ec9edde$export$4b5a99ec12fb6a16 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _syaz5w2r _vr2wstnw",
            (0, $cfgsK.playButtonClassName)
        ])
    }, props.children);
};


const $b59c1ead4d0f2449$export$4b5a99ec12fb6a16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $795b5c887ec9edde$export$4b5a99ec12fb6a16), props);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");




const $bc49482c43b9bdeb$export$b9f4dfad351e8285 = ()=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $cfgsK.backgroundStyles),
        className: (0, $cfgsK.bkgClassName)
    });
};


const $141502dd0f993011$export$fbed5f62d839a0cd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b59c1ead4d0f2449$export$4b5a99ec12fb6a16), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bc49482c43b9bdeb$export$b9f4dfad351e8285), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))), {
        color: "currentColor",
        label: "play"
    }));
};






var $cvXh8 = parcelRequire("cvXh8");




/* tickBoxWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $4jUpC = parcelRequire("4jUpC");

const $baef6411a8802d52$var$selectedStyles = null;
const $baef6411a8802d52$var$wrapperStyles = null;
const $baef6411a8802d52$export$65704ff0d0294857 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "tickBoxWrapper",
        className: (0, $gMc0m.default)([
            "_11c8fhey _2rkov47k _4cvr1h6o _6a6z1h6o _v564ybtr _1bsbpxbi _4t3ipxbi _kqswstnw _154i12x7 _1ltv12x7 _syaz1j28 _1e0c11p5 _1b941ule",
            props.selected && "_bfhkyhbg _syaz5w2r",
            (0, $4jUpC.tickBoxClassName)
        ])
    }, props.children);
};
$baef6411a8802d52$export$65704ff0d0294857.displayName = 'TickBoxWrapper';


const $4bf744bfe3bc43c3$export$65704ff0d0294857 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $baef6411a8802d52$export$65704ff0d0294857), props);
$4bf744bfe3bc43c3$export$65704ff0d0294857.displayName = 'TickBoxWrapper';


const $10df941e43f4629e$export$58be5bf2cd389559 = ({ selected: selected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4bf744bfe3bc43c3$export$65704ff0d0294857), {
        selected: selected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        color: "currentColor",
        label: "tick",
        size: "small"
    }));





/* blanket-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $917092848e4454ee$export$5a1cb4139dc6683d = 'media-card-blanket';
const $917092848e4454ee$export$3141ecf58e7b3585 = `background-color: ${"var(--ds-blanket, #050C1F75)"};`;
const $917092848e4454ee$var$blanketStyles = null;
const $917092848e4454ee$var$fixedBlanketStyle = null;
const $917092848e4454ee$export$5b927fc1ef8c468b = (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_v564ybtr _kqswstnw _1bsb1osq _4t3i1osq _c71l1osq _p12f1osq _1ltvidpf _154iidpf",
            isFixed && "_bfhk1i5c",
            $917092848e4454ee$export$5a1cb4139dc6683d
        ]),
        "data-testid": "media-card-blanket"
    });
};
$917092848e4454ee$export$5b927fc1ef8c468b.displayName = 'Blanket';


const $e1f00eb0e17d524c$export$5b927fc1ef8c468b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $917092848e4454ee$export$5b927fc1ef8c468b), props);





// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $fN2NR = parcelRequire("fN2NR");




var $119a5d44c5f4e83d$export$1092897f622d4253 = /*#__PURE__*/ function(CardActionIconButtonVariant) {
    CardActionIconButtonVariant["default"] = "default";
    CardActionIconButtonVariant["filled"] = "filled";
    return CardActionIconButtonVariant;
}({});
const $119a5d44c5f4e83d$var$getVariantStyles = (variant)=>{
    return variant === 'filled' ? `
    background-color: ${`var(--ds-surface-overlay, ${(0, $kaSe5.rgba)((0, $6fnsQ.N0), 0.8)})`};

    &:hover {
      background-color: ${`var(--ds-surface-overlay-hovered, ${(0, $kaSe5.rgba)((0, $6fnsQ.N0), 0.6)})`}
    }
  ` : `
    &:hover {
      background-color: ${"var(--ds-background-neutral-subtle-hovered, rgba(9, 30, 66, 0.06))"};
    }
  `;
};
const $119a5d44c5f4e83d$export$7554c3d9ed9d9659 = ({ variant: variant })=>/*#__PURE__*/ (0, $9K4OG.css)("appearance:none;border:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.size)(26), {
        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
        '&:hover': {
            cursor: 'pointer'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $119a5d44c5f4e83d$var$getVariantStyles(variant));













/* cardActionButton-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $b904bb3b68d99259$var$variantStyleMap = {
    filled: "_bfhk1bhr _irr36o2t",
    default: "_irr31dpa"
};
const $b904bb3b68d99259$var$cardActionButtonStyles = null;
const $b904bb3b68d99259$export$19effabad32bd757 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $42omo.createElement("button", {
        ...props,
        id: "cardActionButton",
        "data-testid": "media-card-primary-action",
        "aria-label": props.label,
        style: {
            ...props.style,
            cursor: props.disabled ? 'not-allowed' : 'default'
        },
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _r06hglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ou6 _4t3i1ou6 _syaz1q3r _d0altlke",
            $b904bb3b68d99259$var$variantStyleMap[props.variant ?? 'default']
        ])
    }, props.children);
});


const $ab5157d305506a5a$export$19effabad32bd757 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b904bb3b68d99259$export$19effabad32bd757), {
        ...props,
        ref: ref
    }));








const $1eacb67ce1a3c09a$export$8cc1a92de7a95c90 = ({ icon: icon, label: label, filename: filename, triggerColor: triggerColor, onClick: onClick, isPrimary: isPrimary, variant: variant, isDisabled: isDisabled, tooltip: tooltip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // this is to prevent currently focused text to loose cursor on clicking card action
    // this does not prevent onclick behavior
    const onMouseDown = (event)=>{
        event.preventDefault();
    };
    const handleClick = (e)=>{
        const actionSubjectId = isPrimary ? 'mediaCardPrimaryActionButton' : 'mediaCardSecondaryActionButton';
        (0, $bhuzI.fireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                label: label
            }
        }, createAnalyticsEvent);
        onClick?.(e);
    };
    const cardActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab5157d305506a5a$export$19effabad32bd757), {
        onClick: handleClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: triggerColor
        },
        label: filename ? `${filename} \u{2014} ${label}` : label,
        variant: variant,
        disabled: isDisabled
    }, icon);
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip,
        position: "bottom",
        tag: "span"
    }, cardActionButton) : cardActionButton;
};











var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");





const $73314401c141c20c$var$DropdownItemWithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "media-card-actions-menu-item",
        ...props
    });
const $73314401c141c20c$var$createDropdownItemWithAnalytics = (action, index)=>{
    const { label: label, handler: handler, isDisabled: isDisabled } = action;
    const DropdownItemWithAnalytics = (0, $1DWH0.default)({
        onClick: (0, $bhuzI.createAndFireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'mediaCardDropDownMenuItem',
            attributes: {
                label: label
            }
        })
    })($73314401c141c20c$var$DropdownItemWithProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DropdownItemWithAnalytics, {
        key: index,
        onClick: ()=>handler(),
        isDisabled: isDisabled
    }, label);
};
const $73314401c141c20c$export$2b7a7909eccadfb9 = ({ actions: actions, triggerColor: triggerColor, onOpenChange: onOpenChange, triggerVariant: triggerVariant })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (actions.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        testId: "media-card-actions-menu",
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, onClick: onClick, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab5157d305506a5a$export$19effabad32bd757), {
                variant: triggerVariant,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: triggerColor
                },
                ref: triggerRef,
                onClick: (e)=>{
                    (0, $bhuzI.fireMediaCardEvent)({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'mediaCardDropDownMenu',
                        attributes: {}
                    }, createAnalyticsEvent);
                    onClick?.(e);
                },
                ...providedProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                color: "currentColor",
                spacing: "spacious",
                label: "more"
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, actions.map($73314401c141c20c$var$createDropdownItemWithAnalytics)));
    else return null;
};


class $174c79c0a6958200$export$8b95be1301afd485 extends (0, $42omo.Component) {
    render() {
        const { actions: actions } = this.props;
        if (!actions.length) return null;
        const primaryAction = actions.find($174c79c0a6958200$var$actionWithIcon);
        const otherActions = actions.filter($174c79c0a6958200$var$actionNotEqualTo(primaryAction));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, primaryAction ? this.renderActionIconButton(primaryAction, true) : null, this.renderOtherActionButtons(otherActions));
    }
    renderActionIconButton(action, isPrimary) {
        const { triggerColor: triggerColor, filename: filename, variant: variant } = this.props;
        const { icon: icon, handler: handler, label: label, isDisabled: isDisabled, tooltip: tooltip } = action;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eacb67ce1a3c09a$export$8cc1a92de7a95c90), {
            icon: icon,
            label: label,
            filename: filename,
            isPrimary: isPrimary,
            triggerColor: triggerColor,
            onClick: ()=>handler(),
            variant: variant,
            isDisabled: isDisabled,
            tooltip: tooltip
        });
    }
    renderOtherActionButtons(actions) {
        if (actions.length === 0) return null;
        else {
            const { triggerColor: triggerColor, onToggle: onToggle, variant: variant } = this.props;
            const firstActionWithIcon = actions.find($174c79c0a6958200$var$actionWithIcon);
            const otherActions = actions.filter($174c79c0a6958200$var$actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) return this.renderActionIconButton(firstActionWithIcon, false);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $73314401c141c20c$export$2b7a7909eccadfb9), {
                actions: actions,
                triggerColor: triggerColor,
                onOpenChange: onToggle,
                triggerVariant: variant
            });
        }
    }
}
function $174c79c0a6958200$var$actionWithIcon(action) {
    return !!action.icon;
}
function $174c79c0a6958200$var$actionNotEqualTo(otherAction) {
    return (action)=>action !== otherAction;
}





/* actionsBarWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $23552d2c4f42bbc2$export$a7a5a7c9a03af11 = 'media-card-actions-bar';
const $23552d2c4f42bbc2$export$11387bc0e0bf1d5a = `opacity: 1;`;
const $23552d2c4f42bbc2$export$491e6397d7c1480b = (isFixed)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)(isFixed ? $23552d2c4f42bbc2$export$11387bc0e0bf1d5a : 'opacity: 0;', (0, $kaSe5.transition)(), "position:absolute;top:0;right:0;display:flex;flex-flow:row nowrap;justify-content:right;padding:var(--ds-space-100, 8px);gap:var(--ds-space-100, 8px);");
$23552d2c4f42bbc2$export$491e6397d7c1480b.displayName = 'ActionsBarWrapper';


const $9f5fc3f03d4860c4$var$wrapperStyles = null;
const $9f5fc3f03d4860c4$var$fixedActionBarStyle = null;
const $9f5fc3f03d4860c4$export$e9414cbfa812f398 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        className: (0, $gMc0m.default)([
            "_v564ybtr _2lx2vrvc _1n261q9c _zulpu2gc _kqswstnw _154iidpf _1xi2idpf _1e0c1txw _1bahusic _ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _tzy4idpf",
            props.isFixed && "_tzy4kb7n",
            (0, $23552d2c4f42bbc2$export$a7a5a7c9a03af11)
        ]),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        }
    }, props.children);
};
$9f5fc3f03d4860c4$export$e9414cbfa812f398.displayName = 'ActionsBarWrapper';


const $27bf13e5fb509467$export$e9414cbfa812f398 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f5fc3f03d4860c4$export$e9414cbfa812f398), props);


class $27a5a5a4c2677da6$export$8c8e9293b68041de extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isFixed: isFixed, filename: filename, actions: actions } = this.props;
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27bf13e5fb509467$export$e9414cbfa812f398), {
            isFixed: isFixed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $174c79c0a6958200$export$8b95be1301afd485), {
            filename: filename,
            actions: actions,
            variant: (0, $119a5d44c5f4e83d$export$1092897f622d4253).filled
        }));
    }
}





/* iconWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $lBzcF = parcelRequire("lBzcF");

function $33d4f9843e8e045a$export$292aa76b104692f8(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
     // calculate height of the titlebox
    const marginBottom = (0, $lBzcF.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $33d4f9843e8e045a$var$iconWrapperStyles = null;
const $33d4f9843e8e045a$export$be58b4326e23250f = (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "iconWrapper",
        style: {
            height: `calc(100% - ${$33d4f9843e8e045a$export$292aa76b104692f8(hasTitleBox, breakpoint)})`
        },
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ])
    }, props.children);
};
$33d4f9843e8e045a$export$be58b4326e23250f.displayName = 'MediaIconWrapper';


const $e2e329bd2018f2b4$export$be58b4326e23250f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33d4f9843e8e045a$export$be58b4326e23250f), props);








/* iconMessageWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $f18b2bcd098bdb5d$var$breatheAnimation = null;
const $f18b2bcd098bdb5d$var$animatedStyles = null;
const $f18b2bcd098bdb5d$var$baseStyles = null;
const $f18b2bcd098bdb5d$export$e33129280ab99883 = (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "iconMessageWrapper",
        "data-testid": "icon-message-wrapper",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _tzy4kb7n _k48p1wq8 _syaz1rpy _y3gn1h6o _otyr1d21",
            animated && "",
            animated && "_j7hqq7op _5sag1nwe _1pgl1ytf _tip812c5"
        ])
    }, props.children);
};


const $ef68240d118636e1$export$e33129280ab99883 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f18b2bcd098bdb5d$export$e33129280ab99883), props);








const $778b9c3cc4010750$export$49a5d8503f8a110a = ({ messageDescriptor: messageDescriptor, animated: animated = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ef68240d118636e1$export$e33129280ab99883), {
        animated: animated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messageDescriptor)));
};
const $778b9c3cc4010750$export$4a80244213cb4afc = ({ disableAnimation: disableAnimation })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778b9c3cc4010750$export$49a5d8503f8a110a, {
        messageDescriptor: (0, $31QJ7.messages).creating_preview,
        animated: !disableAnimation
    });
const $778b9c3cc4010750$export$35337070c6dafccf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778b9c3cc4010750$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $31QJ7.messages).preview_unavailable
    });
const $778b9c3cc4010750$export$a712c963efa9c728 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778b9c3cc4010750$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $31QJ7.messages).failed_to_load
    });
const $778b9c3cc4010750$export$f6b7f98fc8b4c6c7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778b9c3cc4010750$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $31QJ7.messages).failed_to_upload
    });
const $778b9c3cc4010750$export$acb8738584883d89 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($778b9c3cc4010750$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $31QJ7.messages).check_internet_connection
    });






var $dIgeg = parcelRequire("dIgeg");

function $343dca432ccc3008$export$476aa014e2fd89d5(error) {
    if (!error) return false;
    const { secondaryError: secondaryError } = error;
    // Check if secondaryError is directly a TypeError (fetch API throws TypeError for network errors)
    if (secondaryError instanceof TypeError) return true;
    // Check if secondaryError is a CommonMediaClientError with nested TypeError in innerError
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError) && secondaryError.innerError instanceof TypeError) return true;
    return false;
}





/* imageContainer-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jTudT = parcelRequire("jTudT");

const $358ee1748c4eaa54$var$imageContainerStyles = null;
const $358ee1748c4eaa54$var$imageContainerCenterStyles = null;
const $358ee1748c4eaa54$export$94026ee33dbabc26 = ({ children: children, mediaName: mediaName, status: status, progress: progress, selected: selected, source: source, centerElements: centerElements, mediaCardCursor: mediaCardCursor })=>/*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": (0, $jTudT.fileCardImageViewSelector),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko18qm _1e0c1txw _kqswh2mm _p12f1osq _1bsb1osq _4t3i1osq _c71l1osq",
            centerElements && "_2lx21bp4 _1bah1h6o _4cvr1h6o",
            (0, $jTudT.fileCardImageViewSelector)
        ]),
        "data-test-media-name": mediaName,
        "data-test-status": status,
        "data-test-progress": progress,
        "data-test-selected": selected,
        "data-test-source": source,
        "data-cursor": mediaCardCursor
    }, children);


const $b59dfb3be3d06714$export$94026ee33dbabc26 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $358ee1748c4eaa54$export$94026ee33dbabc26), props);




/* wrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8jrlU = parcelRequire("8jrlU");


var $gxsT9 = parcelRequire("gxsT9");





var $5wBaV = parcelRequire("5wBaV");




const $b8ee99c0fe6f9f5a$export$368b9072d13ed840 = '--media-wrapper-width';
const $b8ee99c0fe6f9f5a$export$838fbe44d5770647 = '--media-wrapper-height';
const $b8ee99c0fe6f9f5a$var$wrapperStyles = {
    default: "_2rko18qm _vchhusvi _kqswh2mm _ect4ttxp _p12f1osq _c71l1osq _1bsb1qmm _4t3ine4n _1hlmd0i9 _1rquusvi _eg541i5c _mts3kb7n _1ntskb7n"
};
const $b8ee99c0fe6f9f5a$var$backgroundStyle = null;
const $b8ee99c0fe6f9f5a$var$shadowStyleMap = {
    withOverlay: "_16qst7xp",
    selected: "_16qsr4us",
    selectedWithOverlay: "_16qsio5t"
};
const $b8ee99c0fe6f9f5a$var$getShadowKey = (disableOverlay, selected)=>{
    if (!disableOverlay && selected) return 'selectedWithOverlay';
    if (!disableOverlay) return 'withOverlay';
    if (selected) return 'selected';
    return '';
};
const $b8ee99c0fe6f9f5a$var$hideNativeBrowserTextSelectionStyles = null;
const $b8ee99c0fe6f9f5a$var$clickableButtonPlayButtonStyles = null;
const $b8ee99c0fe6f9f5a$var$selectableTickboxStyle = null;
const $b8ee99c0fe6f9f5a$var$tooltipStyle = null; // These styles target data attributes to enable the exclusion from TTVC metric calculation.
const $b8ee99c0fe6f9f5a$var$cursorStyle = null;
const $b8ee99c0fe6f9f5a$var$getResponsiveStyles = (breakpoint)=>{
    // dynamically setting the properties to avoid ratcheting build errors. These need to be removed however for the compiled transformation.
    return breakpoint === 'small' ? {
        ['fontSize']: '11px',
        ['lineHeight']: '14px'
    } : {
        ['fontSize']: '14px',
        ['lineHeight']: '22px'
    };
};
const $b8ee99c0fe6f9f5a$export$e6dfd72ab29f8598 = (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, innerRef: innerRef, breakpoint: breakpoint, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    const defaultImageCardDimensions = (0, $3BZZG.getDefaultCardDimensions)(appearance);
    const width = (0, $5wBaV.getCSSUnitValue)(dimensions?.width || defaultImageCardDimensions.width);
    const height = (0, $5wBaV.getCSSUnitValue)(dimensions?.height || defaultImageCardDimensions.height);
    const wrapperShadowKey = $b8ee99c0fe6f9f5a$var$getShadowKey(disableOverlay, selected);
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "newFileExperienceWrapper",
        className: (0, $gMc0m.default)([
            $b8ee99c0fe6f9f5a$var$wrapperStyles.default,
            "_yfmhtlke _5sb1v00u",
            displayBackground && "_bfhki8nm",
            wrapperShadowKey && $b8ee99c0fe6f9f5a$var$shadowStyleMap[wrapperShadowKey],
            selected && "_1p1y1j28 _1rk81j28 _14r11j28 _1np21j28",
            isPlayButtonClickable && "_1y898vuz _19zy8vuz",
            isTickBoxSelectable && "_1yf91j9a _1xp5dgkc",
            shouldDisplayTooltip && "_9m3z1osq _10pb1osq",
            (0, $8jrlU.newFileExperienceClassName)
        ]),
        "data-testid": testId,
        style: {
            [$b8ee99c0fe6f9f5a$export$368b9072d13ed840]: width,
            [$b8ee99c0fe6f9f5a$export$838fbe44d5770647]: height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$b8ee99c0fe6f9f5a$var$getResponsiveStyles(breakpoint)
        },
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }, /*#__PURE__*/ $42omo.createElement((0, $cbc8g.default), {
        data: {
            hasMediaComponent: true
        }
    }), props.children);
};
$b8ee99c0fe6f9f5a$export$e6dfd72ab29f8598.displayName = 'NewFileExperienceWrapper';


const $e128a0cddcc2a271$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8ee99c0fe6f9f5a$export$e6dfd72ab29f8598), props);






var $6tawD = parcelRequire("6tawD");









var $8C5kA = parcelRequire("8C5kA");





var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");

const $54b3b5aa4b2b8705$var$OpenMediaViewerButton = ({ fileName: fileName, innerRef: innerRef, ...props })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ref: innerRef,
        ...props
    }, intl.formatMessage((0, $31QJ7.messages).open_file_in_viewer, {
        name: fileName
    })));
};
const $54b3b5aa4b2b8705$var$OpenMediaViewerButtonWrapper = (props)=>{
    return props.intl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($54b3b5aa4b2b8705$var$OpenMediaViewerButton, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($54b3b5aa4b2b8705$var$OpenMediaViewerButton, props));
};
var $54b3b5aa4b2b8705$export$2e2bcd8739ae039 = (0, $gmMgo.default)($54b3b5aa4b2b8705$var$OpenMediaViewerButtonWrapper, {
    enforceContext: false
});









/* svgImage-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $f95f4106fb62208e$export$56f32e61c4316384 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};



var $gLC1Y = parcelRequire("gLC1Y");

var $lpgfG = parcelRequire("lpgfG");

const $f05d12acc620519e$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $f05d12acc620519e$var$svgRendererStyles = null;
const $f05d12acc620519e$var$svgRendererMaxDimensionStyles = null;
const $f05d12acc620519e$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const [didSvgRender, setDidSvgRender] = (0, $42omo.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $42omo.useState)({});
    const imgRef = (0, $42omo.useRef)(null);
    const calculateDimensions = (0, $42omo.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $f95f4106fb62208e$export$56f32e61c4316384)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $ihjDz.MediaCardError)($f05d12acc620519e$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $42omo.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $lpgfG.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        style: {
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $gLC1Y.MediaSVGError)('img-error'));
        },
        ref: imgRef,
        className: (0, $gMc0m.default)([
            "_5ral1f51 _bfhku67f",
            !width && !height && "_p12f1osq _c71l1osq"
        ])
    }) : null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 














const $6e4a615da12de54f$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $6e4a615da12de54f$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const onSvgError = (err)=>{
        const error = new (0, $ihjDz.MediaCardError)($6e4a615da12de54f$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    const { svgUrl: svgUrl, source: source } = (0, $lpgfG.useResolveSvg)(identifier, onSvgError);
    const cardPreview = (0, $42omo.useMemo)(()=>svgUrl && source ? {
            dataURI: svgUrl,
            source: source
        } : undefined, [
        svgUrl,
        source
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f48d6082771fffe1$export$a8e6523ab063becd), {
        testId: "media-card-svg",
        identifier: identifier,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        onImageLoad: onLoad,
        onImageError: ()=>{
            onSvgError(new (0, $gLC1Y.MediaSVGError)('img-error'));
        },
        wrapperRef: wrapperRef,
        mediaType: "image",
        useWhiteBackground: true
    }) : null;
};


const $dace2568efcc61e8$export$cf98b60e5f1e2515 = (props)=>{
    return (0, $dh538.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e4a615da12de54f$export$cf98b60e5f1e2515), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05d12acc620519e$export$cf98b60e5f1e2515), props);
};





const $943db6e2668fd17a$export$fe522702db3259fa = ({ identifier: identifier, innerRef: innerRef = null, onImageLoad: onImageLoad, onImageError: onImageError, dimensions: dimensions, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, metadata: metadata, status: status, selected: selected, selectable: selectable, cardPreview: cardPreview, mediaCardCursor: mediaCardCursor, shouldHideTooltip: shouldHideTooltip, progress: progress, alt: alt, resizeMode: resizeMode, onDisplayImage: onDisplayImage, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, actions: actions, disableOverlay: disableOverlay, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, error: error, disableAnimation: disableAnimation, openMediaViewerButtonRef: openMediaViewerButtonRef = null, shouldOpenMediaViewer: shouldOpenMediaViewer, overriddenCreationDate: overriddenCreationDate, onSvgError: onSvgError, onSvgLoad: onSvgLoad })=>{
    const [didSvgRender, setDidSvgRender] = (0, $42omo.useState)(false);
    const [didImageRender, setDidImageRender] = (0, $42omo.useState)(false);
    const divRef = (0, $42omo.useRef)(null);
    const prevCardPreviewRef = (0, $42omo.useRef)();
    const breakpoint = (0, $6tawD.useBreakpoint)(dimensions?.width, divRef);
    (0, $42omo.useEffect)(()=>{
        // We should only switch didImageRender to false when cardPreview goes undefined, not when it is changed. as this method could be triggered after onImageLoad callback, falling on a race condition
        if (prevCardPreviewRef.current && !cardPreview) setDidImageRender(false);
        prevCardPreviewRef.current = cardPreview;
    }, [
        cardPreview
    ]);
    const handleOnImageLoad = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        /*
        We render the icon & icon message always, even if there is cardPreview available.
        If the image fails to load/render, the icon will remain, i.e. the user won't see a change until the root card decides to chage status to error.
        If the image renders successfully, we switch this variable to hide the icon & icon message behind the thumbnail in case the image has transparency.
        It is less likely that root component replaces a suceeded cardPreview for a failed one than the opposite case. Therefore we prefer to hide the icon instead show when the image fails, for a smoother transition
      */ setDidImageRender(true);
        onImageLoad?.(cardPreview);
    };
    const handleOnImageError = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        setDidImageRender(false);
        onImageError?.(cardPreview);
    };
    const shouldRenderPlayButton = ()=>{
        const { mediaType: mediaType } = metadata || {};
        if (mediaType !== 'video' || !cardPreview) return false;
        return true;
    };
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        divRef,
        innerRef
    ]);
    const getRenderConfigByStatus = ()=>{
        const { name: name, mediaType: mediaType, mimeType: mimeType } = metadata || {};
        const isZeroSize = metadata && metadata.size === 0;
        const defaultConfig = {
            renderTypeIcon: !didImageRender && !didSvgRender,
            renderImageRenderer: !didSvgRender,
            renderSvgView: mimeType === 'image/svg+xml',
            renderPlayButton: !!cardPreview && mediaType === 'video',
            renderBlanket: !disableOverlay,
            renderTitleBox: !disableOverlay,
            renderTickBox: !disableOverlay && !!selectable
        };
        const loadingConfig = {
            ...defaultConfig,
            renderPlayButton: false,
            renderTypeIcon: false,
            renderSpinner: !didImageRender && !didSvgRender
        };
        switch(status){
            case 'uploading':
                return {
                    ...defaultConfig,
                    renderBlanket: !disableOverlay || mediaType !== 'video',
                    isFixedBlanket: true,
                    renderProgressBar: true
                };
            case 'processing':
                return {
                    ...defaultConfig,
                    iconMessage: !didImageRender && !isZeroSize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778b9c3cc4010750$export$4a80244213cb4afc), {
                        disableAnimation: disableAnimation
                    }) : undefined
                };
            case 'complete':
                return defaultConfig;
            case 'error':
            case 'failed-processing':
                if (status === 'failed-processing' && mimeType === 'image/svg+xml') return loadingConfig;
                const baseErrorConfig = {
                    ...defaultConfig,
                    renderTypeIcon: true,
                    renderImageRenderer: false,
                    renderSvgView: false,
                    renderTitleBox: false,
                    renderPlayButton: false
                };
                let iconMessage;
                let customTitleMessage;
                if ((0, $ihjDz.isUploadError)(error)) {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778b9c3cc4010750$export$f6b7f98fc8b4c6c7), null);
                    customTitleMessage = (0, $31QJ7.messages).failed_to_upload;
                } else if ((0, $343dca432ccc3008$export$476aa014e2fd89d5)(error) && (0, $dh538.fg)('media_card_failed_messaging_ui_revamp')) {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778b9c3cc4010750$export$acb8738584883d89), null);
                    customTitleMessage = (0, $31QJ7.messages).check_internet_connection;
                } else if (!metadata) iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778b9c3cc4010750$export$a712c963efa9c728), null);
                else iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $778b9c3cc4010750$export$35337070c6dafccf), null);
                if (!disableOverlay) {
                    const renderFailedTitleBox = !name || !!customTitleMessage;
                    return {
                        ...baseErrorConfig,
                        renderTitleBox: !!name && !customTitleMessage,
                        renderFailedTitleBox: renderFailedTitleBox,
                        iconMessage: !renderFailedTitleBox ? iconMessage : undefined,
                        customTitleMessage: customTitleMessage
                    };
                }
                return {
                    ...baseErrorConfig,
                    iconMessage: iconMessage
                };
            case 'loading-preview':
            case 'loading':
            default:
                return loadingConfig;
        }
    };
    const { renderTypeIcon: renderTypeIcon, iconMessage: iconMessage, renderImageRenderer: renderImageRenderer, renderSvgView: renderSvgView, renderSpinner: renderSpinner, renderPlayButton: renderPlayButton, renderBlanket: renderBlanket, renderProgressBar: renderProgressBar, renderTitleBox: renderTitleBox, renderFailedTitleBox: renderFailedTitleBox, renderTickBox: renderTickBox, isFixedBlanket: isFixedBlanket, customTitleMessage: customTitleMessage } = getRenderConfigByStatus();
    const shouldDisplayBackground = !cardPreview || !disableOverlay || status === 'error' || status === 'failed-processing';
    const isPlayButtonClickable = shouldRenderPlayButton() && !!disableOverlay;
    const isTickBoxSelectable = !disableOverlay && !!selectable && !selected;
    // Disable tooltip for Media Single
    const shouldDisplayTooltip = !disableOverlay && !shouldHideTooltip;
    const { mediaType: mediaType, mimeType: mimeType, name: name, createdAt: createdAt } = metadata || {};
    const isTitleBoxVisible = renderTitleBox && name;
    const hasVisibleTitleBox = !!(isTitleBoxVisible || renderFailedTitleBox);
    const metadataRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(metadata);
    const actionsWithDetails = (0, $42omo.useMemo)(()=>{
        if (!actions) return [];
        return actions.map((action)=>({
                ...action,
                handler: ()=>{
                    if (!metadataRef.current) action.handler();
                    else action.handler({
                        type: 'file',
                        details: metadataRef.current
                    });
                }
            }));
    }, [
        actions,
        metadataRef
    ]);
    const onSvgLoadBase = ()=>{
        setDidSvgRender(true);
        onSvgLoad?.();
    };
    const contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b59dfb3be3d06714$export$94026ee33dbabc26), {
        centerElements: didSvgRender && !(0, $dh538.fg)('platform_media_card_image_render'),
        testId: (0, $jTudT.fileCardImageViewSelector),
        mediaName: name,
        status: status,
        progress: progress,
        mediaCardCursor: mediaCardCursor,
        selected: selected,
        source: cardPreview?.source
    }, renderTypeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2e329bd2018f2b4$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cneVc.MimeTypeIcon), {
        testId: "media-card-file-type-icon",
        mediaType: mediaType,
        mimeType: mimeType,
        name: name
    }), iconMessage), renderSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2e329bd2018f2b4$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        testId: "media-card-loading",
        interactionName: "media-card-loading"
    })), renderSvgView && identifier && (0, $e63NX.isFileIdentifier)(identifier) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dace2568efcc61e8$export$cf98b60e5f1e2515), {
        identifier: identifier,
        resizeMode: resizeMode || 'crop',
        onError: onSvgError,
        onLoad: onSvgLoadBase,
        wrapperRef: divRef
    }), renderImageRenderer && identifier && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $484e134ecbfafbbc$export$a8e6523ab063becd), {
        cardPreview: cardPreview,
        mediaType: metadata?.mediaType || 'unknown',
        alt: alt ?? name,
        resizeMode: resizeMode,
        onDisplayImage: onDisplayImage,
        onImageLoad: handleOnImageLoad,
        onImageError: handleOnImageError,
        nativeLazyLoad: nativeLazyLoad,
        forceSyncDisplay: forceSyncDisplay,
        identifier: identifier,
        wrapperRef: divRef
    }), renderPlayButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e2e329bd2018f2b4$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $141502dd0f993011$export$fbed5f62d839a0cd), null)), renderBlanket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1f00eb0e17d524c$export$5b927fc1ef8c468b), {
        isFixed: isFixedBlanket
    }), renderTitleBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23621622fab39a6b$export$e3ce443f3b72c291), {
        name: name,
        createdAt: overriddenCreationDate ?? createdAt,
        breakpoint: breakpoint,
        titleBoxIcon: titleBoxIcon,
        titleBoxBgColor: titleBoxBgColor,
        hidden: !isTitleBoxVisible
    }), renderFailedTitleBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64661f5936e4ae88$export$9b3b0baef32e2e39), {
        breakpoint: breakpoint,
        customMessage: customTitleMessage
    }), renderProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4nZRJ.ProgressBar), {
        progress: progress,
        breakpoint: breakpoint,
        positionBottom: !hasVisibleTitleBox
    }), renderTickBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10df941e43f4629e$export$58be5bf2cd389559), {
        selected: selected
    })), disableOverlay || !actions || actions.length === 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27a5a5a4c2677da6$export$8c8e9293b68041de), {
        filename: name,
        actions: actionsWithDetails
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldOpenMediaViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $54b3b5aa4b2b8705$export$2e2bcd8739ae039), {
        fileName: name ?? '',
        innerRef: openMediaViewerButtonRef,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e128a0cddcc2a271$export$e6dfd72ab29f8598), {
        testId: testId || 'media-card-view',
        dimensions: dimensions,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        innerRef: mergedRef,
        breakpoint: breakpoint,
        mediaCardCursor: mediaCardCursor,
        disableOverlay: !!disableOverlay,
        selected: !!selected,
        displayBackground: shouldDisplayBackground,
        isPlayButtonClickable: isPlayButtonClickable,
        isTickBoxSelectable: isTickBoxSelectable,
        shouldDisplayTooltip: shouldDisplayTooltip
    }, shouldDisplayTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: name,
        position: "bottom",
        tag: "div"
    }, contents) : contents));
};
const $943db6e2668fd17a$export$7e52c821f7b6f422 = (0, $1DWH0.default)({
    onClick: (0, $bhuzI.createAndFireMediaCardEvent)({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'mediaCard',
        attributes: {}
    })
})($943db6e2668fd17a$export$fe522702db3259fa);


const $391bfff60e778804$export$fb4230f160368c88 = ()=>performance.now();


const $adfd4fe64d78ffe5$export$b7c988f139757a90 = ({ mediaClient: mediaClient, appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, dimensions: dimensions, contextId: contextId, alt: alt, actions: actions, shouldOpenMediaViewer: shouldOpenMediaViewer, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const cardDimensions = dimensions || (0, $3BZZG.getDefaultCardDimensions)(appearance);
    const internalOccurrenceKey = (0, $42omo.useMemo)(()=>(0, $e742eeee478b46f8$export$48da330df5248c4c)(), []);
    const timeElapsedTillCommenced = (0, $42omo.useMemo)(()=>(0, $391bfff60e778804$export$fb4230f160368c88)(), []);
    // Generate unique traceId for file
    const traceContext = (0, $42omo.useMemo)(()=>({
            traceId: (0, $fCrf0.getRandomTelemetryId)()
        }), []);
    const fileStateFlagsRef = (0, $42omo.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const shouldSendPerformanceEvent = (0, $42omo.useMemo)(()=>(0, $f7feab67f02696f1$export$b21c64f4f93d10f4)(), []);
    // UFO experience hook - creates a unique experience instance per card
    const ufoExperience = (0, $f7feab67f02696f1$export$a42e845f664e6373)({
        instanceId: internalOccurrenceKey,
        enabled: shouldSendPerformanceEvent
    });
    const startUfoExperienceRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        ufoExperience.start();
    });
    const [status, setStatus] = (0, $42omo.useState)('loading-preview');
    const cardPreview = (0, $42omo.useMemo)(()=>({
            dataURI: identifier.dataURI,
            orientation: 1,
            source: 'external'
        }), [
        identifier.dataURI
    ]);
    const metadata = {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
    const fileAttributes = {
        fileMediatype: 'image',
        fileId: metadata.id
    };
    // for analytics
    const ssrReliability = {
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    };
    const [previewDidRender, setPreviewDidRender] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)();
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $42omo.useState)(null);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        const timeElapsedTillEvent = (0, $391bfff60e778804$export$fb4230f160368c88)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $704b605b60b0a22f$export$a1fb57756f0de62b)(createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error, traceContext, undefined);
        // External images don't use SSR - no ssrPreviewInfo passed
        ufoExperience.complete(status, fileAttributes, fileStateFlagsRef.current, ssrReliability, error, undefined);
    });
    const fireAbortedEventRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        ufoExperience.abort({
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //------------------------ useEffects ----------------------------//
    //----------------------------------------------------------------//
    (0, $42omo.useEffect)(()=>{
        startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef
    ]);
    const prevStatus = (0, $93fac9ac27817247$export$5cae361ad82dce8b)(status);
    (0, $42omo.useEffect)(()=>{
        if (prevStatus !== undefined && status !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        status
    ]);
    (0, $42omo.useEffect)(()=>{
        if (previewDidRender && status === 'loading-preview') setStatus('complete');
    }, [
        previewDidRender,
        status
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    //---------------------- Render Functions ------------------------//
    //----------------------------------------------------------------//
    const renderMediaViewer = ()=>{
        if (!mediaViewerSelectedItem) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7NoXb.default), {
            collectionName: '',
            items: mediaViewerItems || [],
            mediaClientConfig: mediaClient.config,
            selectedItem: mediaViewerSelectedItem,
            onClose: ()=>{
                setMediaViewerSelectedItem(null);
            },
            contextId: contextId,
            featureFlags: featureFlags
        }), document.body);
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $05cb2a5058fcf886$export$c364ca3a4cf16be0)(false, !!shouldOpenMediaViewer, status === 'error', !!cardPreview, metadata.mediaType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $943db6e2668fd17a$export$7e52c821f7b6f422), {
        identifier: identifier,
        status: status,
        error: error,
        mediaItemType: identifier.mediaItemType,
        metadata: metadata,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        dimensions: cardDimensions,
        actions: actions,
        selectable: selectable,
        selected: selected,
        onClick: (event, analyticsEvent)=>{
            if (onClick) {
                const cardEvent = {
                    event: event,
                    mediaItemDetails: metadata
                };
                onClick(cardEvent, analyticsEvent);
            }
            if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
                mediaItemType: 'external-image',
                dataURI: identifier.dataURI,
                name: identifier.name
            });
        },
        onMouseEnter: (event)=>{
            onMouseEnter?.({
                event: event,
                mediaItemDetails: metadata
            });
        },
        disableOverlay: disableOverlay,
        onDisplayImage: ()=>{
            const payloadPart = {
                fileId: identifier.dataURI,
                isUserCollection: false
            };
            (0, $eGqQQ.globalMediaEventEmitter).emit('media-viewed', {
                viewingLevel: 'minimal',
                ...payloadPart
            });
        },
        testId: testId,
        titleBoxBgColor: titleBoxBgColor,
        titleBoxIcon: titleBoxIcon,
        onImageError: (newCardPreview)=>{
            // If the dataURI has been replaced, we can dismiss this error
            if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
            const error = new (0, $ihjDz.ImageLoadError)(newCardPreview?.source);
            setStatus('error');
            setError(error);
        },
        onImageLoad: (newCardPreview)=>{
            // If the dataURI has been replaced, we can dismiss this callback
            if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
            setPreviewDidRender(true);
        },
        mediaCardCursor: mediaCardCursor,
        shouldHideTooltip: shouldHideTooltip
    }), mediaViewerSelectedItem ? renderMediaViewer() : null);
};







const $d9b7b5c152c79314$export$dc1fb2767ac9a82f = (resizeMode)=>resizeMode === 'stretchy-fit' ? 'full-fit' : resizeMode;


var $hZ6O7 = parcelRequire("hZ6O7");

var $3x2Xc = parcelRequire("3x2Xc");




var $2nsxJ = parcelRequire("2nsxJ");

var $jRNsq = parcelRequire("jRNsq");




var $JXmwv = parcelRequire("JXmwv");

var $24z7I = parcelRequire("24z7I");















function $534b2a44d2a5b317$export$2f19d859969045b7() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}



var $2OM7p = parcelRequire("2OM7p");





var $lCTpI = parcelRequire("lCTpI");

const $62752fdbac604199$export$9dd9ef980c055cad = (value)=>value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));


const $35d35d3aeafcbabd$export$726bc1818ebaed3b = (dimension, options)=>{
    const retinaFactor = (0, $534b2a44d2a5b317$export$2f19d859969045b7)() ? 2 : 1;
    const dimensionValue = options.dimensions && options.dimensions[dimension] || '';
    if ((0, $lCTpI.isValidPercentageUnit)(dimensionValue) && options.element) return (0, $2OM7p.getElementDimension)(options.element, dimension) * retinaFactor;
    if (typeof dimensionValue === 'number') return dimensionValue * retinaFactor;
    if ((0, $62752fdbac604199$export$9dd9ef980c055cad)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10) * retinaFactor;
    return (0, $3BZZG.defaultImageCardDimensions)[dimension] * retinaFactor;
};
const $35d35d3aeafcbabd$export$5b11506bddb36f50 = (options)=>{
    const width = $35d35d3aeafcbabd$export$726bc1818ebaed3b('width', options);
    const height = $35d35d3aeafcbabd$export$726bc1818ebaed3b('height', options);
    return {
        width: width,
        height: height
    };
};
const $35d35d3aeafcbabd$export$a94e513ca3122718 = (dimensionName, { dimensions: dimensions, element: element })=>{
    const dimensionValue = dimensions?.[dimensionName] || '';
    if ((0, $lCTpI.isValidPercentageUnit)(dimensionValue) && element) return (0, $2OM7p.getElementDimension)(element, dimensionName);
    if (typeof dimensionValue === 'number') return dimensionValue;
    if ((0, $62752fdbac604199$export$9dd9ef980c055cad)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10);
    return (0, $3BZZG.defaultImageCardDimensions)[dimensionName];
};
const $35d35d3aeafcbabd$export$f187979e6522f007 = (options)=>{
    const width = $35d35d3aeafcbabd$export$a94e513ca3122718('width', options);
    const height = $35d35d3aeafcbabd$export$a94e513ca3122718('height', options);
    return {
        width: width,
        height: height
    };
};








const $29f1124e2b38ef5b$var$getProcessingStatusFromFileState = (status)=>{
    switch(status){
        case 'processed':
            return 'succeeded';
        case 'processing':
            return 'running';
        case 'failed-processing':
            return 'failed';
    }
};
const $29f1124e2b38ef5b$var$getFileDetailsFromFileState = (state)=>({
        id: state.id,
        name: state.name,
        size: state.size,
        mimeType: state.mimeType,
        createdAt: state.createdAt,
        mediaType: state.mediaType,
        processingStatus: $29f1124e2b38ef5b$var$getProcessingStatusFromFileState(state.status),
        failReason: state.status === 'failed-processing' ? state.failReason : undefined
    });
const $29f1124e2b38ef5b$export$7e125c11d42de4d1 = (identifier, fileState)=>{
    return (0, $e63NX.isFileIdentifier)(identifier) ? fileState && !(0, $hZ6O7.isErrorFileState)(fileState) ? $29f1124e2b38ef5b$var$getFileDetailsFromFileState(fileState) : {
        id: identifier.id
    } : {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
};









var $b1Jpy = parcelRequire("b1Jpy");

var $ff5225fc2301cfe8$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};


const $8c45481407298b79$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP = 900; //px
const $8c45481407298b79$var$createIntersectionObserverCallback = (onVisible)=>(entries, observer)=>{
        for (let entry of entries)if (entry.isIntersecting) {
            onVisible();
            observer.disconnect();
            break;
        }
    };
const $8c45481407298b79$var$ViewportObserver = ({ onVisible: onVisible, cardEl: cardEl, children: children })=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const onVisibleCallback = (0, $42omo.useCallback)(()=>{
        setIsVisible(true);
        onVisible();
    }, [
        onVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        let intersectionObserver;
        try {
            intersectionObserver = new IntersectionObserver($8c45481407298b79$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: (0, $ff5225fc2301cfe8$export$2e2bcd8739ae039)(),
                rootMargin: `${$8c45481407298b79$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        } catch (error) {
            intersectionObserver = new IntersectionObserver($8c45481407298b79$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: null,
                rootMargin: `${$8c45481407298b79$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        }
        cardEl && intersectionObserver.observe(cardEl);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        cardEl,
        onVisibleCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), {
        ignore: !isVisible
    }, children);
};
const $8c45481407298b79$export$35aa735df177ee7c = ({ cardEl: cardEl, onVisible: onVisible, children: children })=>{
    if (typeof IntersectionObserver === 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8c45481407298b79$var$ViewportObserver, {
        cardEl: cardEl,
        onVisible: onVisible
    }, children);
};














const $478e56f5775ff3df$export$c7e2887eae92d53c = /*#__PURE__*/ (0, $42omo.lazy)(async ()=>{
    const { InlinePlayer: InlinePlayer } = await (parcelRequire("dhURv"));
    return {
        default: InlinePlayer
    };
});



var $k0QVR = parcelRequire("k0QVR");





var $9aGns = parcelRequire("9aGns");




function $96defe31f0d409dd$export$1390767202e8e51e(actions, details) {
    return actions.map((action)=>({
            ...action,
            handler: ()=>{
                action.handler({
                    type: 'file',
                    details: details
                });
            }
        }));
}
const $96defe31f0d409dd$export$948607b7587fecda = (baseAction, formatMessage)=>{
    const { isDisabled: isDisabled } = baseAction;
    const label = isDisabled ? 'Download Disabled' : 'Download';
    const tooltip = isDisabled ? formatMessage((0, $31QJ7.messages).download_disabled_security_policy) : undefined;
    return {
        ...baseAction,
        label: label,
        tooltip: tooltip,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9aGns))), {
            color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : 'currentColor',
            spacing: "spacious",
            label: "Download"
        })
    };
};






const $61a22ecc6dee7c82$export$5bc85d7cf4a39f3e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);






var $4QMC0 = parcelRequire("4QMC0");





var $lMdlY = parcelRequire("lMdlY");


var $1pSma = parcelRequire("1pSma");

const $bd93736384abc3ec$var$traceContextRetriever = ()=>{
    const trace = (0, $lMdlY.getActiveTrace)();
    if (trace && (0, $dh538.fg)('platform-filecard-ufo-trace')) return {
        traceId: trace?.traceId,
        spanId: trace?.spanId
    };
    else return {
        traceId: (0, $fCrf0.getRandomTelemetryId)()
    };
};
const $bd93736384abc3ec$export$593fd10f7e6c6505 = ({ appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', isLazy: isLazy = true, disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, ssr: ssr, dimensions: dimensions, originalDimensions: originalDimensions, contextId: contextId, alt: alt, actions: actions, shouldEnableDownloadButton: shouldEnableDownloadButton, useInlinePlayer: useInlinePlayer, shouldOpenMediaViewer: shouldOpenMediaViewer, onFullscreenChange: onFullscreenChange, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter, videoControlsWrapperRef: videoControlsWrapperRef, viewerOptions: viewerOptions, includeHashForDuplicateFiles: includeHashForDuplicateFiles, ssrItemDetails: ssrItemDetails, onError: onError })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isAbuseModalOpen, setIsAbuseModalOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const pressTracing = (0, $1pSma.default)('click-file-card');
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const [cardElement, setCardElement] = (0, $42omo.useState)(null);
    // use reference here to avoid excessive calls.
    const onErrorRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(onError);
    const cardDimensions = dimensions || (0, $3BZZG.getDefaultCardDimensions)(appearance);
    // Calculate the preview dimensions if card dimensions are "percentage" based
    const previewDimensions = (0, $42omo.useMemo)(()=>// resolving dimensions is eventually an expensive operation if the dimensions are a percentage
        // thus needs to be memoized
        (0, $35d35d3aeafcbabd$export$f187979e6522f007)({
            dimensions: cardDimensions,
            element: cardElement
        }), [
        cardDimensions,
        cardElement
    ]);
    const [isCardVisible, setIsCardVisible] = (0, $42omo.useState)(!isLazy);
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(identifier.id, {
        skipRemote: !isCardVisible,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey,
        includeHashForDuplicateFiles: includeHashForDuplicateFiles
    });
    const prevFileState = (0, $93fac9ac27817247$export$5cae361ad82dce8b)(fileState && (0, $hZ6O7.isErrorFileState)(fileState) ? undefined : fileState);
    const fileStateValue = (0, $42omo.useMemo)(()=>{
        if (fileState && !(0, $hZ6O7.isErrorFileState)(fileState)) return fileState;
        return prevFileState;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fileState
    ]);
    const dateOverrides = (0, $42omo.useContext)((0, $61a22ecc6dee7c82$export$5bc85d7cf4a39f3e));
    const overridenDate = dateOverrides?.[identifier.id];
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const internalOccurrenceKey = (0, $42omo.useMemo)(()=>(0, $e742eeee478b46f8$export$48da330df5248c4c)(), []);
    const timeElapsedTillCommenced = (0, $42omo.useMemo)(()=>(0, $391bfff60e778804$export$fb4230f160368c88)(), []);
    const fileStateFlagsRef = (0, $42omo.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const mediaViewerButtonRef = (0, $42omo.useRef)(null);
    // Generate unique traceId for file
    const traceContext = (0, $42omo.useMemo)($bd93736384abc3ec$var$traceContextRetriever, []);
    const [status, setStatus] = (0, $42omo.useState)('loading');
    const [isPlayingFile, setIsPlayingFile] = (0, $42omo.useState)(false);
    const [shouldAutoplay, setShouldAutoplay] = (0, $42omo.useState)(false);
    const [previewDidRender, setPreviewDidRender] = (0, $42omo.useState)(false);
    const mediaBlobUrlAttrs = (0, $42omo.useMemo)(()=>{
        const { id: id, collectionName: collection } = identifier;
        const { mimeType: mimeType, name: name, size: size } = (0, $29f1124e2b38ef5b$export$7e125c11d42de4d1)(identifier, fileStateValue);
        return contextId ? {
            id: id,
            collection: collection,
            contextId: contextId,
            mimeType: mimeType,
            name: name,
            size: size,
            ...originalDimensions || previewDimensions,
            alt: alt
        } : undefined;
    }, [
        alt,
        previewDimensions,
        contextId,
        fileStateValue,
        identifier,
        originalDimensions
    ]);
    const { preview: preview, status: previewStatus, error: previewError, nonCriticalError: nonCriticalError, ssrReliability: ssrReliability, onImageError: onImageErrorBase, onImageLoad: onImageLoadBase, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $k0QVR.useFilePreview)({
        useSrcSet: true,
        mediaBlobUrlAttrs: mediaBlobUrlAttrs,
        resizeMode: (0, $d9b7b5c152c79314$export$dc1fb2767ac9a82f)(resizeMode),
        identifier: identifier,
        ssr: ssr,
        dimensions: previewDimensions,
        traceContext: traceContext,
        skipRemote: !isCardVisible,
        source: 'mediaCard'
    });
    const shouldSendPerformanceEvent = (0, $42omo.useMemo)(()=>(0, $f7feab67f02696f1$export$b21c64f4f93d10f4)(), []);
    // UFO experience hook - creates a unique experience instance per card
    const ufoExperience = (0, $f7feab67f02696f1$export$a42e845f664e6373)({
        instanceId: internalOccurrenceKey,
        enabled: shouldSendPerformanceEvent
    });
    const [error, setError] = (0, $42omo.useState)();
    // CXP-2723 TODO: TEMPORARY VARIABLES
    const finalError = error || (previewError && previewError.primaryReason !== 'failed-processing' && fileStateValue?.mimeType !== 'image/svg+xml' ? previewError : undefined);
    const finalStatus = finalError ? 'error' : status === 'failed-processing' && fileStateValue?.mimeType === 'image/svg+xml' ? 'loading-preview' : status;
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $42omo.useState)(null);
    const uploadProgressRef = (0, $42omo.useRef)();
    // Store latest auth provider event (emit with fireOperationalEventRef)
    const pendingAuthProviderEventRef = (0, $42omo.useRef)(null);
    const metadata = (0, $42omo.useMemo)(()=>{
        const getProcessingStatusFromFileState = (status)=>{
            switch(status){
                case 'processed':
                    return 'succeeded';
                case 'processing':
                    return 'running';
                case 'failed-processing':
                    return 'failed';
            }
        };
        if ((0, $dh538.fg)('dfo_attachments_late_render_fix')) {
            if (fileStateValue) return {
                id: fileStateValue.id,
                name: fileStateValue.name || ssrItemDetails && ssrItemDetails.filename,
                size: fileStateValue.size,
                mimeType: fileStateValue.mimeType || ssrItemDetails && ssrItemDetails.mimetype,
                createdAt: fileStateValue.createdAt || ssrItemDetails && ssrItemDetails.createdDate,
                mediaType: fileStateValue.mediaType,
                processingStatus: getProcessingStatusFromFileState(fileStateValue.status),
                failReason: fileStateValue.status === 'failed-processing' ? fileStateValue.failReason : undefined
            };
            else return {
                id: identifier.id,
                name: ssrItemDetails && ssrItemDetails.filename,
                mimeType: ssrItemDetails && ssrItemDetails.mimetype,
                createdAt: ssrItemDetails && ssrItemDetails.createdDate
            };
        } else {
            if (fileStateValue) return {
                id: fileStateValue.id,
                name: fileStateValue.name,
                size: fileStateValue.size,
                mimeType: fileStateValue.mimeType,
                createdAt: fileStateValue.createdAt,
                mediaType: fileStateValue.mediaType,
                processingStatus: getProcessingStatusFromFileState(fileStateValue.status),
                failReason: fileStateValue.status === 'failed-processing' ? fileStateValue.failReason : undefined
            };
            else return {
                id: identifier.id
            };
        }
    }, [
        fileStateValue,
        identifier.id,
        ssrItemDetails
    ]);
    const fileAttributes = (0, $42omo.useMemo)(()=>{
        return {
            fileMediatype: metadata.mediaType,
            fileMimetype: metadata.mimeType,
            fileId: metadata.id,
            fileSize: metadata.size,
            fileStatus: fileStateValue?.status
        };
    }, [
        fileStateValue?.status,
        metadata.id,
        metadata.mediaType,
        metadata.mimeType,
        metadata.size
    ]);
    const downloadFn = (0, $42omo.useCallback)(async ()=>{
        try {
            await mediaClient.file.downloadBinary(identifier.id, metadata.name, identifier.collectionName, traceContext);
            (0, $704b605b60b0a22f$export$8f39639231268ced)(createAnalyticsEvent, fileAttributes, traceContext, fileStateValue?.metadataTraceContext);
        } catch (e) {
            const error = new (0, $ihjDz.MediaCardError)('download', e);
            (0, $704b605b60b0a22f$export$f0368e92a624442a)(createAnalyticsEvent, fileAttributes, error, traceContext, fileStateValue?.metadataTraceContext);
        }
    }, [
        createAnalyticsEvent,
        fileAttributes,
        fileStateValue?.metadataTraceContext,
        identifier.collectionName,
        identifier.id,
        mediaClient.file,
        metadata.name,
        traceContext
    ]);
    const computedActions = (0, $42omo.useMemo)(()=>{
        if (finalStatus === 'failed-processing' || shouldEnableDownloadButton) {
            const handler = async ()=>{
                if (!!fileStateValue?.abuseClassification) setIsAbuseModalOpen(true);
                else await downloadFn();
            };
            const downloadAction = (0, $96defe31f0d409dd$export$948607b7587fecda)({
                handler: handler,
                isDisabled: mediaClient.config.enforceDataSecurityPolicy
            }, formatMessage);
            return [
                downloadAction,
                ...actions ?? []
            ];
        } else return actions;
    }, [
        actions,
        mediaClient.config.enforceDataSecurityPolicy,
        shouldEnableDownloadButton,
        finalStatus,
        formatMessage,
        fileStateValue?.abuseClassification,
        downloadFn
    ]);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        const timeElapsedTillEvent = (0, $391bfff60e778804$export$fb4230f160368c88)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $704b605b60b0a22f$export$a1fb57756f0de62b)(createAnalyticsEvent, finalStatus, fileAttributes, performanceAttributes, ssrReliability, finalError, traceContext, fileStateValue?.metadataTraceContext, metadata.failReason);
        // Emit stored auth provider events when card reaches final state
        if (createAnalyticsEvent && pendingAuthProviderEventRef.current && [
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus) && (0, $dh538.fg)('platform_media_auth_provider_analytics')) {
            const authEvent = pendingAuthProviderEventRef.current;
            // Sample auth-provider-succeeded events at 10%
            const shouldSampleAuthProviderSucceeded = ()=>Math.random() < 0.1;
            if (authEvent.type === 'succeeded') // Emit success events when card completes (or errors - auth can succeed even if card fails)
            {
                if (shouldSampleAuthProviderSucceeded()) (0, $bhuzI.fireMediaCardEvent)((0, $bhuzI.getAuthProviderSucceededPayload)(authEvent.payload.durationMs, authEvent.payload.timeoutMs, authEvent.payload.authContext), createAnalyticsEvent);
            } else if (authEvent.type === 'failed') // Always emit failed events (no sampling)
            (0, $bhuzI.fireMediaCardEvent)((0, $bhuzI.getAuthProviderFailedPayload)(authEvent.payload.durationMs, authEvent.payload.timeoutMs, authEvent.payload.error, authEvent.payload.authContext), createAnalyticsEvent);
            pendingAuthProviderEventRef.current = null;
        }
        // Determine SSR preview info for UFO timing strategy
        // wasSSRAttempted is only true when SSR was used AND preview exists AND preview is non-lazy
        // because lazy SSR defers loading, so it behaves like CSR for timing purposes
        // We also require preview to exist to avoid false positives when:
        // 1. ssr='client' but no SSR data exists (client-side navigation)
        // 2. Non-previewable files (e.g., zip files) where no preview is generated
        const isSSRNonLazy = !!ssr && !!preview && preview.lazy !== true;
        const wasSSRSuccessful = isSSRNonLazy && (ssrReliability.server?.status === 'success' || ssrReliability.client?.status === 'success');
        const ssrPreviewInfo = {
            dataUri: preview?.dataURI,
            srcset: preview?.srcSet,
            wasSSRAttempted: isSSRNonLazy,
            wasSSRSuccessful: wasSSRSuccessful
        };
        ufoExperience.complete(finalStatus, fileAttributes, fileStateFlagsRef.current, ssrReliability, finalError, ssrPreviewInfo);
    });
    const fireNonCriticalErrorEventRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)((error)=>{
        createAnalyticsEvent && (0, $704b605b60b0a22f$export$6505e60579e04cbd)(createAnalyticsEvent, finalStatus, fileAttributes, ssrReliability, error, traceContext, fileStateValue?.metadataTraceContext);
    });
    (0, $42omo.useEffect)(()=>{
        if (nonCriticalError) fireNonCriticalErrorEventRef.current(nonCriticalError);
    }, [
        nonCriticalError,
        fireNonCriticalErrorEventRef
    ]);
    const startUfoExperienceRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        // For non-lazy SSR previews, use interaction start time as the experience start time
        // because the image loading started at interaction start, not at mount time
        const isSSRNonLazy = !!ssr && preview?.lazy !== true;
        ufoExperience.start({
            useInteractionTime: isSSRNonLazy
        });
    });
    const fireAbortedEventRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        ufoExperience.abort({
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    // Listen to auth provider events and store them (don't emit yet)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_media_auth_provider_analytics')) return;
        const onAuthSuccess = (payload)=>{
            // Store latest auth provider event for later emission when card status changes
            pendingAuthProviderEventRef.current = {
                type: 'succeeded',
                payload: payload
            };
        };
        const onAuthFailed = (payload)=>{
            // Store latest auth provider event for later emission when card status changes
            pendingAuthProviderEventRef.current = {
                type: 'failed',
                payload: payload
            };
        };
        (0, $eGqQQ.globalMediaEventEmitter).on('auth-provider-succeeded', onAuthSuccess);
        (0, $eGqQQ.globalMediaEventEmitter).on('auth-provider-failed', onAuthFailed);
        return ()=>{
            (0, $eGqQQ.globalMediaEventEmitter).off('auth-provider-succeeded', onAuthSuccess);
            (0, $eGqQQ.globalMediaEventEmitter).off('auth-provider-failed', onAuthFailed);
        };
    }, []);
    //----------------------------------------------------------------//
    //--------------------- Handling Errors---------------------------//
    //----------------------------------------------------------------//
    (0, $42omo.useEffect)(()=>{
        if (onErrorRef.current && finalError) {
            const errorReason = finalError.primaryReason;
            onErrorRef.current(errorReason);
        }
    }, [
        finalError,
        onErrorRef
    ]);
    //----------------------------------------------------------------//
    //--------------------- Focus on Close Viewer  -------------------//
    //----------------------------------------------------------------//
    const wasViewerPreviouslyOpen = (0, $93fac9ac27817247$export$5cae361ad82dce8b)(mediaViewerSelectedItem);
    (0, $42omo.useEffect)(()=>{
        if (wasViewerPreviouslyOpen && !mediaViewerSelectedItem) mediaViewerButtonRef.current?.focus();
    }, [
        wasViewerPreviouslyOpen,
        mediaViewerSelectedItem
    ]);
    //----------------------------------------------------------------//
    //---------------------- Callbacks & Handlers  -------------------//
    //----------------------------------------------------------------//
    const onSvgError = (error)=>{
        setError(error);
        setStatus('error');
    };
    const onImageError = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageErrorBase(newCardPreview);
    };
    const onSvgLoad = ()=>{
        setPreviewDidRender(true);
    };
    const onImageLoad = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageLoadBase(newCardPreview);
        setPreviewDidRender(true);
    };
    const onCardClick = (event, analyticsEvent)=>{
        if (onClick) {
            const cardEvent = {
                event: event,
                mediaItemDetails: metadata
            };
            onClick(cardEvent, analyticsEvent);
        }
    };
    const onCardViewClick = (event, analyticsEvent)=>{
        onCardClick(event, analyticsEvent);
        if (!metadata) return;
        const isVideo = metadata.mediaType === 'video';
        const isBrowserSupported = metadata.mimeType && (0, $JXmwv.isMimeTypeSupportedByBrowser)(metadata.mimeType);
        // TODO: this should be handled by Inline Player
        const isPlayable = !!fileState && (fileState.status === 'processed' || isBrowserSupported && [
            'processing',
            'uploading'
        ].includes(fileState.status));
        if (useInlinePlayer && isVideo && isPlayable && finalStatus !== 'error') {
            setIsPlayingFile(true);
            setShouldAutoplay(true);
        } else if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
            id: identifier.id,
            mediaItemType: 'file',
            collectionName: identifier.collectionName,
            occurrenceKey: identifier.occurrenceKey
        });
        // Abort VC when click file card
        pressTracing();
    };
    //----------------------------------------------------------------//
    //----------------- update status flags --------------------------//
    //----------------------------------------------------------------//
    (0, $42omo.useEffect)(()=>{
        if (fileStateValue?.status === 'processing') fileStateFlagsRef.current.wasStatusProcessing = true;
        else if (fileStateValue?.status === 'uploading') fileStateFlagsRef.current.wasStatusUploading = true;
    }, [
        fileStateValue?.status
    ]);
    //----------------------------------------------------------------//
    //---------------- fetch and resolve card preview ----------------//
    //----------------------------------------------------------------//
    const prevStatus = (0, $93fac9ac27817247$export$5cae361ad82dce8b)(finalStatus);
    const prevIsCardVisible = (0, $93fac9ac27817247$export$5cae361ad82dce8b)(isCardVisible);
    (0, $42omo.useEffect)(()=>{
        if (prevStatus !== undefined && finalStatus !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        finalStatus
    ]);
    (0, $42omo.useEffect)(()=>{
        const turnedVisible = !prevIsCardVisible && isCardVisible;
        if (turnedVisible) startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef,
        isCardVisible,
        prevIsCardVisible
    ]);
    //----------------------------------------------------------------//
    //----------------- set isPlayingFile state ----------------------//
    //----------------------------------------------------------------//
    (0, $42omo.useEffect)(()=>{
        const isVideo = fileAttributes.fileMediatype === 'video';
        const { mimeType: mimeType } = (0, $29f1124e2b38ef5b$export$7e125c11d42de4d1)(identifier, fileStateValue);
        const isVideoPlayable = mimeType && (0, $24z7I.isVideoMimeTypeSupportedByBrowser)(mimeType) || fileStateValue && (0, $hZ6O7.isProcessedFileState)(fileStateValue);
        if (/**
     * We need to check that the card is visible before switching to inline player
     * in order to avoid race conditions of the ViewportDector being unmounted before
     * it is able to set isCardVisible to true.
     */ isCardVisible && isVideo && !isPlayingFile && disableOverlay && useInlinePlayer && isVideoPlayable && fileStateValue?.status !== 'failed-processing' && finalStatus !== 'error') setIsPlayingFile(true);
    }, [
        isCardVisible,
        disableOverlay,
        fileAttributes.fileMediatype,
        fileStateValue,
        identifier,
        isPlayingFile,
        finalStatus,
        useInlinePlayer
    ]);
    //----------------------------------------------------------------//
    //----------------- abort UFO experience -------------------------//
    //----------------------------------------------------------------//
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    // Update Status
    //----------------------------------------------------------------//
    const updateFileStateRef = (0, $b757c0672a5eef1f$export$b3e10e1f0fbb71db)(()=>{
        // This effect has race condition with Complete effect. We share the same check to ovid status overrides
        // do not update the card status if the status is final
        if ([
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus)) return;
        if (previewDidRender && // We should't complete if status is uploading
        [
            'loading-preview',
            'processing'
        ].includes(finalStatus)) setStatus('complete');
        else if (fileState) {
            if (fileState.status !== 'error') {
                let newStatus;
                switch(fileState.status){
                    case 'uploading':
                    case 'failed-processing':
                    case 'processing':
                        newStatus = fileState.status;
                        break;
                    case 'processed':
                        // Set complete if processing is done and there is no preview
                        if (!preview && previewStatus === 'complete') {
                            newStatus = 'complete';
                            break;
                        }
                        newStatus = 'loading-preview';
                        break;
                    default:
                        newStatus = 'loading';
                }
                const newProgress = newStatus === 'uploading' && fileState.status === 'uploading' ? fileState.progress : 1;
                setStatus(newStatus);
                uploadProgressRef.current = newProgress;
            } else {
                const e = (0, $dIgeg.toCommonMediaClientError)(fileState);
                const errorReason = finalStatus === 'uploading' ? 'upload' : 'metadata-fetch';
                setError(new (0, $ihjDz.MediaCardError)(errorReason, e));
                setStatus('error');
            }
        }
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        setCardElement,
        copyNodeRef
    ]);
    (0, $42omo.useEffect)(()=>{
        updateFileStateRef.current();
    }, [
        fileState,
        preview,
        previewStatus,
        updateFileStateRef,
        previewDidRender,
        finalStatus
    ]);
    //----------------------------------------------------------------//
    // Shared Card View & SVG View resources
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $05cb2a5058fcf886$export$c364ca3a4cf16be0)(!!useInlinePlayer, !!shouldOpenMediaViewer, finalStatus === 'error' || finalStatus === 'failed-processing', !!preview, metadata.mediaType);
    const onImageMouseEnter = (event)=>{
        onMouseEnter?.({
            event: event,
            mediaItemDetails: metadata
        });
    };
    //----------------------------------------------------------------//
    //---------------------- Render Card Function --------------------//
    //----------------------------------------------------------------//
    const renderCard = (withCallbacks = true, cardStatusOverride, izLazyOverride)=>{
        const { mediaItemType: mediaItemType } = identifier;
        const isLazyWithOverride = izLazyOverride === undefined ? isLazy : izLazyOverride;
        let isLazyPreview = (0, $dh538.fg)('media-perf-lazy-loading-optimisation') ? preview?.lazy : true;
        // We should natively lazy load an SSR preview when card is not visible,
        // otherwise we'll fire the metadata fetch from outside the viewport
        // Side note: We should not lazy load if the cardPreview is available from local cache,
        // in order to avoid flickers during re-mount of the component
        // CXP-2723 TODO: Create test cases for the above scenarios
        const nativeLazyLoad = isLazyWithOverride && ((0, $dh538.fg)('media-perf-uplift-mutation-fix') || !isCardVisible) && preview && (0, $31b9f913d9ecc724$export$dea79d05143ccf4)(preview) && isLazyPreview;
        // Force Media Image to always display img for SSR
        const forceSyncDisplay = !!ssr;
        const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $943db6e2668fd17a$export$7e52c821f7b6f422), {
            identifier: identifier,
            status: cardStatusOverride || finalStatus,
            error: finalError,
            mediaItemType: mediaItemType,
            metadata: metadata,
            cardPreview: preview,
            alt: alt,
            resizeMode: resizeMode,
            dimensions: cardDimensions,
            actions: computedActions,
            selectable: selectable,
            selected: selected,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            openMediaViewerButtonRef: mediaViewerButtonRef,
            onClick: withCallbacks ? onCardViewClick : undefined,
            onMouseEnter: withCallbacks ? onImageMouseEnter : undefined,
            disableOverlay: disableOverlay,
            progress: uploadProgressRef.current,
            onDisplayImage: withCallbacks ? ()=>{
                const payloadPart = {
                    fileId: identifier.id,
                    isUserCollection: identifier.collectionName === (0, $3x2Xc.RECENTS_COLLECTION)
                };
                (0, $eGqQQ.globalMediaEventEmitter).emit('media-viewed', {
                    viewingLevel: 'minimal',
                    ...payloadPart
                });
            } : undefined,
            innerRef: mergedRef,
            testId: testId,
            titleBoxBgColor: titleBoxBgColor,
            titleBoxIcon: titleBoxIcon,
            onImageError: withCallbacks ? onImageError : undefined,
            onImageLoad: withCallbacks ? onImageLoad : undefined,
            onSvgError: onSvgError,
            onSvgLoad: onSvgLoad,
            nativeLazyLoad: nativeLazyLoad,
            forceSyncDisplay: forceSyncDisplay,
            mediaCardCursor: mediaCardCursor,
            shouldHideTooltip: shouldHideTooltip,
            overriddenCreationDate: overridenDate
        });
        return isLazyWithOverride ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c45481407298b79$export$35aa735df177ee7c), {
            cardEl: cardElement,
            onVisible: ()=>{
                setIsCardVisible(true);
            }
        }, card) : card;
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const inlinePlayerFallback = isPlayingFile ? renderCard(false, 'loading', false) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const collectionName = identifier.collectionName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !!fileStateValue?.abuseClassification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QMC0.AbuseModal), {
        isOpen: isAbuseModalOpen,
        onConfirm: downloadFn,
        onClose: ()=>setIsAbuseModalOpen(false)
    }), isPlayingFile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: inlinePlayerFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $478e56f5775ff3df$export$c7e2887eae92d53c), {
        dimensions: cardDimensions,
        originalDimensions: originalDimensions,
        identifier: identifier,
        autoplay: !!shouldAutoplay,
        onFullscreenChange: onFullscreenChange,
        onError: (e)=>{
            setError(new (0, $ihjDz.MediaCardError)('error-file-state', e));
            setStatus('error');
            setIsPlayingFile(false);
        },
        onClick: onCardClick,
        selected: selected,
        ref: setCardElement,
        testId: testId,
        cardPreview: preview,
        videoControlsWrapperRef: videoControlsWrapperRef
    })) : renderCard(), mediaViewerSelectedItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7NoXb.default), {
        collectionName: collectionName,
        items: mediaViewerItems || [],
        mediaClientConfig: mediaClient.config,
        selectedItem: mediaViewerSelectedItem,
        onClose: ()=>{
            setMediaViewerSelectedItem(null);
        },
        contextId: contextId,
        featureFlags: featureFlags,
        viewerOptions: viewerOptions
    }) : null, getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", getSsrScriptProps()));
};



var $7bPHJ = parcelRequire("7bPHJ");







const $d851a782d1429e2c$var$getStartedAt = (entry, interactionStartTime)=>entry.startTime - interactionStartTime;
const $d851a782d1429e2c$var$getCommonMetrics = (entry)=>({
        tcpHandshakeTime: {
            end: entry.connectEnd,
            start: entry.connectStart
        },
        dnsLookupTime: {
            end: entry.domainLookupEnd,
            start: entry.domainLookupStart
        },
        redirectTimeTaken: {
            end: entry.redirectEnd,
            start: entry.redirectStart
        },
        tlsConnectNegotiationTime: {
            end: entry.requestStart,
            start: entry.secureConnectionStart
        },
        timeTakenToFetchWithoutRedirect: {
            end: entry.responseEnd,
            start: entry.fetchStart
        },
        /**
	 * `interimRequestTime` represents the entire time the browser took to
	 * request the resource from the server. This includes the interim response time
	 * (for example, 100 Continue or 103 Early Hints).
	 *
	 * i.e. It is the time taken for the request to be sent
	 * + the waiting time for the server to send a response
	 *
	 * Please, note that this value
	 * is distinctly different from the aforementioned document.
	 */ interimRequestTime: {
            end: entry.responseStart,
            start: entry.requestStart
        },
        /**
	 * `requestInvocationTime` represents the actual time the browser took to request
	 * the resource from the server (i.e. it does not include the interim reponse
	 * time).
	 * NOTE: it relies on an experimental feature (`firstInterimResponseStart`) that is
	 * available in Chrome, but not in FireFox or Safari. This value will be undefined
	 * when `firstInterimResponseStart` is unavailable.
	 */ requestInvocationTime: entry.firstInterimResponseStart ? {
            end: entry.firstInterimResponseStart,
            start: entry.requestStart
        } : undefined,
        /**
	 * `contentDownloadTime` represents the time taken for the browser to receive
	 * the resource from the server. This may be cut short if the transport
	 * connection is closed.
	 */ contentDownloadTime: {
            end: entry.responseEnd,
            start: entry.responseStart
        }
    });
const $d851a782d1429e2c$var$calculateCommonDurations = (metrics)=>Object.fromEntries(Object.entries(metrics).map(([key, marks])=>{
        if (!marks) return [
            key,
            undefined
        ];
        const { start: start, end: end } = marks;
        return [
            key,
            end - start
        ];
    }));
const $d851a782d1429e2c$export$b22670df0917866e = (entry, interactionStartTime)=>{
    return {
        startedAt: $d851a782d1429e2c$var$getStartedAt(entry, interactionStartTime),
        /**
		 * Performance resource timing data regarding the loading of an
		 * application's resources as described in
		 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
		 */ transferSize: entry.transferSize,
        decodedBodySize: entry.decodedBodySize,
        totalDuration: entry.duration,
        initiatorType: entry.initiatorType,
        endedAt: entry.responseEnd - interactionStartTime,
        responseEnd: entry.responseEnd,
        browserCacheHit: entry.transferSize === 0,
        nextHopProtocol: entry.nextHopProtocol,
        ...$d851a782d1429e2c$var$calculateCommonDurations($d851a782d1429e2c$var$getCommonMetrics(entry)),
        /**
		 * The user agent string for the current browser
		 * Read more: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
		 */ userAgent: window.navigator.userAgent,
        /**
		 * Performance resource timing data sent by the server. This includes:
		 *
		 * `cdnCacheHit` is a boolean determining whether the CDN cache was hit or missed.
		 *
		 * `cdnDownstreamFBL` is the 'CDN Downstream First Byte Latency'. It represents
		 * how long the it took the CDN to respond to the frontend.
		 *
		 * `cdnUpstreamFBL` is the 'CDN Upstream First Byte Latency'. It represents the
		 * time the Media backend took to respond to the CDN, in the case that the CDN
		 * cache was a miss. Notably, this timing is a subset of the `cdnDownstreamFBL` timing.
		 */ cdnCacheHit: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-cache-hit';
        }) ? true : false,
        cdnDownstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-downstream-fbl';
        })?.duration,
        cdnUpstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-upstream-fbl';
        })?.duration
    };
};
const $d851a782d1429e2c$var$filterCommonMetrics = (metrics)=>Object.fromEntries(Object.entries(metrics).filter(([, marks])=>!!marks));
const $d851a782d1429e2c$export$45a6f341f1a26a5d = (entry, interactionStartTime)=>{
    // Calculate timing relative to UFO interaction start time
    // For page_load: interactionStartTime = 0 (relative to page navigation)
    // For transitions: interactionStartTime = performance.now() when transition started
    // This ensures metrics work correctly for both initial loads and SPA soft redirects
    const relativeStartTime = entry.startTime - interactionStartTime;
    return {
        resourceTiming: {
            start: relativeStartTime,
            end: entry.responseEnd,
            size: entry.transferSize
        },
        ...$d851a782d1429e2c$var$filterCommonMetrics($d851a782d1429e2c$var$getCommonMetrics(entry))
    };
};





const $819e027392a48e69$var$mediaLabelStack = [
    {
        name: 'media'
    }
];
const $819e027392a48e69$export$be8beb5937d1436e = (ufoDurationMetrics, endpoint)=>{
    const labelStack = [
        ...$819e027392a48e69$var$mediaLabelStack,
        {
            name: endpoint
        }
    ];
    Object.entries(ufoDurationMetrics).map(([name, { start: start, end: end, size: size }])=>{
        (0, $4u5NT.addCustomSpans)(name, start, end, size, labelStack);
    });
};


const $f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY = '__mediaCardPerfState_asflkajsdflja';
// this should fire around 10% of the time
const $f4ce55fcb5bfc91c$var$shouldSamplePerfObserver = ()=>Math.random() < 0.1;
const $f4ce55fcb5bfc91c$var$urlRegex = /(?:https:\/\/(?:media\.(?:dev|staging|prod)\.atl-paas\.net|api\.media\.atlassian\.com|media-cdn(?:\.stg\.|\.)atlassian\.com)\/|media-api\/)file\/([^/]+)\/image.*[?&]source=mediaCard/;
const $f4ce55fcb5bfc91c$var$clientIdParamRegex = /[?&]clientId=([^&]+)/;
const $f4ce55fcb5bfc91c$var$ssrParamRegex = /[?&]token=([^&]+)/;
const $f4ce55fcb5bfc91c$var$createAndGetResourceObserver = ()=>{
    return new PerformanceObserver((list)=>{
        list.getEntries().forEach((baseEntry)=>{
            const entry = baseEntry;
            const matchFileId = entry.name.match($f4ce55fcb5bfc91c$var$urlRegex);
            const matchClientId = entry.name.match($f4ce55fcb5bfc91c$var$clientIdParamRegex);
            const matchSSR = entry.name.match($f4ce55fcb5bfc91c$var$ssrParamRegex);
            if (matchFileId && window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardCreateAnalyticsEvent) {
                const fileId = matchFileId[1];
                const clientId = matchClientId?.[1];
                const ssr = matchSSR ? 'server' : undefined;
                // Get UFO interaction start time for proper timing in SPAs
                // For page_load: start = 0 (relative to page navigation)
                // For transitions: start = performance.now() when transition started
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const interactionStartTime = interaction?.start ?? 0;
                const mediaDurationMetrics = (0, $d851a782d1429e2c$export$b22670df0917866e)(entry, interactionStartTime);
                const event = window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'mediaCardPerfObserver',
                    attributes: {
                        ssr: ssr,
                        fileId: fileId,
                        mediaClientId: clientId,
                        featureFlags: {
                            'media-perf-lazy-loading-optimisation': (0, $dh538.fg)('media-perf-lazy-loading-optimisation')
                        },
                        ...mediaDurationMetrics
                    }
                });
                if ($f4ce55fcb5bfc91c$var$shouldSamplePerfObserver()) event.fire((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL));
                if ((0, $dh538.fg)('platform_media_card_ufo_network_metrics')) {
                    const ufoDurationMetrics = (0, $d851a782d1429e2c$export$45a6f341f1a26a5d)(entry, interactionStartTime);
                    const endpointName = 'image';
                    (0, $819e027392a48e69$export$be8beb5937d1436e)(ufoDurationMetrics, endpointName);
                }
            }
        });
    });
};
const $f4ce55fcb5bfc91c$export$70c58d75bd83664 = (newAnalyticsContext)=>{
    if (!window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY]) window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent = newAnalyticsContext;
};
const $f4ce55fcb5bfc91c$var$isDefinedPerformanceObserver = ()=>typeof window['PerformanceObserver'] !== 'undefined';
const $f4ce55fcb5bfc91c$export$8840d7cbe19419a0 = ()=>{
    if (!$f4ce55fcb5bfc91c$var$isDefinedPerformanceObserver()) return;
    if (window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardPerfObserver) return;
    if (!window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY]) window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver = $f4ce55fcb5bfc91c$var$createAndGetResourceObserver();
    window[$f4ce55fcb5bfc91c$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver.observe({
        type: 'resource',
        buffered: true
    });
};






var $lxDfD = parcelRequire("lxDfD");

const $9260ce48a32625e1$var$packageName = "platform-pkg";
const $9260ce48a32625e1$var$packageVersion = "0.0.0-use.local";
const $9260ce48a32625e1$export$7a6ccaf429ad93a8 = ({ identifier: identifier, ...otherProps })=>{
    const innerContent = (0, $e63NX.isFileIdentifier)(identifier) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
        name: "media-card-file-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd93736384abc3ec$export$593fd10f7e6c6505), {
        ...otherProps,
        identifier: identifier,
        key: identifier.id
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
        name: "media-card-external-image"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $adfd4fe64d78ffe5$export$b7c988f139757a90), {
        ...otherProps,
        identifier: identifier,
        key: identifier.dataURI
    }));
    return otherProps.intl ? innerContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
        locale: "en"
    }, innerContent);
};
const $9260ce48a32625e1$export$ec84c9f4597a734b = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        (0, $f4ce55fcb5bfc91c$export$8840d7cbe19419a0)();
    }, []);
    (0, $42omo.useEffect)(()=>{
        (0, $f4ce55fcb5bfc91c$export$70c58d75bd83664)(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9260ce48a32625e1$export$7a6ccaf429ad93a8, props);
};
const $9260ce48a32625e1$export$60332b2344f7fe41 = (0, $lw3De.withMediaAnalyticsContext)({
    packageVersion: $9260ce48a32625e1$var$packageVersion,
    packageName: $9260ce48a32625e1$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $gmMgo.default)($9260ce48a32625e1$export$ec84c9f4597a734b, {
    enforceContext: false
}));





const $4ce875230b064c2e$export$91b1a6414631318a = (props)=>{
    const { dimensions: dimensions, onClick: onClick } = props;
    const Card = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if ((0, $dh538.fg)('platform_media_video_captions')) return (0, $8wnNT.withMediaClientAndSettings)((0, $9260ce48a32625e1$export$60332b2344f7fe41));
        return (0, $7soXU.withMediaClient)((0, $9260ce48a32625e1$export$60332b2344f7fe41));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7313f275e0b9b090$export$2e2bcd8739ae039), {
        dimensions: dimensions,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Card, props));
};
module.exports["CardWithMediaClient"] = $4ce875230b064c2e$export$91b1a6414631318a;

});

parcelRegister("8wnNT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");


var $8IHds = parcelRequire("8IHds");

const $644dfef8d55a6120$export$ea8f1b8e2d843039 = (Component)=>({ mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings, ...otherProps })=>{
        const parsedSettings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
        const mediaProviderValue = (0, $42omo.useContext)((0, $9k33u.MediaContext));
        const mediaClientValue = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
        const mediaContext = (0, $42omo.useMemo)(()=>({
                mediaClient: mediaProviderValue?.mediaClient ?? mediaClientValue ?? (0, $grxv4.getMediaClient)(mediaClientConfig),
                settings: {
                    ...mediaProviderValue?.settings,
                    ...parsedSettings
                }
            }), [
            mediaProviderValue?.settings,
            mediaProviderValue?.mediaClient,
            parsedSettings,
            mediaClientConfig,
            mediaClientValue
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9k33u.MediaContext).Provider, {
            value: mediaContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaContext.mediaClient,
                mediaSettings: mediaContext.settings
            })
        });
    };
module.exports["withMediaClientAndSettings"] = $644dfef8d55a6120$export$ea8f1b8e2d843039;

});

parcelRegister("lw3De", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $gSKON = parcelRequire("gSKON");

const $7cb3645b740b6517$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $42omo.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $gSKON.MEDIA_CONTEXT)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
                data: contextData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                ref: ref
            }));
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${// @ts-ignore displayName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };
module.exports["withMediaAnalyticsContext"] = $7cb3645b740b6517$export$ba0fb5f6ba6ce56c;

});

parcelRegister("bhuzI", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");


var $7bPHJ = parcelRequire("7bPHJ");

var $wA8SJ = parcelRequire("wA8SJ");


var $eWRwJ = parcelRequire("eWRwJ");

const $4e9e5bfba2b350c8$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $4e9e5bfba2b350c8$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, samplingRate)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext,
            ...samplingRate !== undefined && {
                samplingRate: samplingRate
            }
        }
    });
const $4e9e5bfba2b350c8$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $4e9e5bfba2b350c8$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $4e9e5bfba2b350c8$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4e9e5bfba2b350c8$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4e9e5bfba2b350c8$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $4e9e5bfba2b350c8$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $4e9e5bfba2b350c8$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4e9e5bfba2b350c8$export$4af9d71992e89714(error),
        error: $4e9e5bfba2b350c8$export$88c61dcad53762da(error),
        errorDetail: $4e9e5bfba2b350c8$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4e9e5bfba2b350c8$export$29aa614726672b2e(error)
    };
};
const $4e9e5bfba2b350c8$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>{
    const requestMetadata = $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    };
};
const $4e9e5bfba2b350c8$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>{
    const requestMetadata = $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            traceContext: traceContext
        }
    };
};
const $4e9e5bfba2b350c8$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>{
    const requestMetadata = $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error);
    return {
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    };
};
const $4e9e5bfba2b350c8$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, processingFailReason)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            // 'not-available' is used for cases before processingFailReason implementation (backward compatibility)
            processingFailReason: processingFailReason || 'not-available',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
// Similar to extractErrorInfo but works with raw Error (not MediaCardError)
const $4e9e5bfba2b350c8$var$extractAuthProviderErrorInfo = (error)=>{
    if ((0, $dIgeg.isCommonMediaClientError)(error)) return {
        failReason: error.reason,
        error: error.reason,
        errorDetail: error.innerError?.message ?? error.message
    };
    return {
        failReason: error.name || 'unknown',
        error: error.name || '',
        errorDetail: error.message
    };
};
// Extract collection name from authContext - supports both new `access` array and deprecated `collectionName`
const $4e9e5bfba2b350c8$var$getCollectionNameFromAuthContext = (authContext)=>{
    if (!authContext) return undefined;
    // Try new access array first
    const collectionAccess = authContext.access?.find((a)=>a.type === 'collection');
    if (collectionAccess && 'name' in collectionAccess) return collectionAccess.name;
    // Fallback to deprecated collectionName
    return authContext.collectionName;
};
const $4e9e5bfba2b350c8$export$8ae7a3e1eee1037e = (durationMs, timeoutMs, authContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaAuthProvider',
        attributes: {
            status: 'succeeded',
            durationMs: durationMs,
            timeoutMs: timeoutMs,
            collectionName: $4e9e5bfba2b350c8$var$getCollectionNameFromAuthContext(authContext)
        }
    });
const $4e9e5bfba2b350c8$export$ad4b9061e2cb7f76 = (durationMs, timeoutMs, error, authContext)=>{
    const errorInfo = $4e9e5bfba2b350c8$var$extractAuthProviderErrorInfo(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaAuthProvider',
        attributes: {
            status: 'failed',
            durationMs: durationMs,
            timeoutMs: timeoutMs,
            collectionName: $4e9e5bfba2b350c8$var$getCollectionNameFromAuthContext(authContext),
            ...errorInfo
        }
    };
};
function $4e9e5bfba2b350c8$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL));
    }
}
const $4e9e5bfba2b350c8$export$4d33ada3618f7626 = (payload)=>{
    return (0, $eWRwJ.default)((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL))((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
};
module.exports["getRenderSucceededEventPayload"] = $4e9e5bfba2b350c8$export$4006df18b24ad838;
module.exports["getDownloadSucceededEventPayload"] = $4e9e5bfba2b350c8$export$30f484b360b0efe8;
module.exports["getRenderErrorRequestMetadata"] = $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e;
module.exports["extractErrorInfo"] = $4e9e5bfba2b350c8$export$74aaf4784c2edb2c;
module.exports["getRenderErrorEventPayload"] = $4e9e5bfba2b350c8$export$ea8620de23983ca1;
module.exports["getDownloadFailedEventPayload"] = $4e9e5bfba2b350c8$export$bd721ce2bd18db4c;
module.exports["getErrorEventPayload"] = $4e9e5bfba2b350c8$export$d3944464e6ecd3d4;
module.exports["getRenderFailedFileStatusPayload"] = $4e9e5bfba2b350c8$export$116834b91a04bd49;
module.exports["getAuthProviderSucceededPayload"] = $4e9e5bfba2b350c8$export$8ae7a3e1eee1037e;
module.exports["getAuthProviderFailedPayload"] = $4e9e5bfba2b350c8$export$ad4b9061e2cb7f76;
module.exports["fireMediaCardEvent"] = $4e9e5bfba2b350c8$export$60729f3fb03dcecc;
module.exports["createAndFireMediaCardEvent"] = $4e9e5bfba2b350c8$export$4d33ada3618f7626;

});

parcelRegister("7bPHJ", function(module, exports) {
const $f5d20cba8da3e43a$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $f5d20cba8da3e43a$export$ec1779cb96554e1;

});

parcelRegister("wA8SJ", function(module, exports) {

var $chIYi = parcelRequire("chIYi");


var $fl9IL = parcelRequire("fl9IL");

const $19999d8625134b0f$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($chIYi)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $19999d8625134b0f$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $19999d8625134b0f$export$e24d38cbdf73bc1a = (payload)=>$19999d8625134b0f$var$hasFileAttributesWithFileId(payload) ? (0, $fl9IL.produce)(payload, $19999d8625134b0f$var$sanitiseFileId) : payload;
module.exports["sanitiseAnalyticsPayload"] = $19999d8625134b0f$export$e24d38cbdf73bc1a;

});

parcelRegister("ihjDz", function(module, exports) {
class $197aaa08f701d50c$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $197aaa08f701d50c$export$2c035820a31723e extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$10ab445310d30114 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$18e89b7e50818288 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $197aaa08f701d50c$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $197aaa08f701d50c$export$d0a45ab59b4606b extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(source){
        super($197aaa08f701d50c$export$921ab4548acefaa4(source));
    }
}
function $197aaa08f701d50c$export$36b43e3dd9a92(err) {
    return err instanceof $197aaa08f701d50c$export$ec8d022824f41295;
}
const $197aaa08f701d50c$export$b380593ba3516c6f = (err)=>err instanceof $197aaa08f701d50c$export$2c035820a31723e;
const $197aaa08f701d50c$export$e1d87830b3784f94 = (err)=>err instanceof $197aaa08f701d50c$export$10ab445310d30114;
const $197aaa08f701d50c$export$443aeb298d35d79d = (err)=>$197aaa08f701d50c$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $197aaa08f701d50c$export$f00bb5a138da22e1(err) {
    return err instanceof $197aaa08f701d50c$export$d0a45ab59b4606b;
}
const $197aaa08f701d50c$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($197aaa08f701d50c$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error);
};
const $197aaa08f701d50c$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';
module.exports["MediaCardError"] = $197aaa08f701d50c$export$ec8d022824f41295;
module.exports["ImageLoadError"] = $197aaa08f701d50c$export$d0a45ab59b4606b;
module.exports["isUploadError"] = $197aaa08f701d50c$export$11f9f5835c5b9a04;

});

parcelRegister("cneVc", function(module, exports) {
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a6JW6 = parcelRequire("a6JW6");


var $dv4ij = parcelRequire("dv4ij");

const $486f7da454853fe7$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $486f7da454853fe7$var$iconWrapperStyles = null; /*
                                 * Renders an icon. First, check if the mimeType corresponds to any of the special mimeType icons (.gif, .sketch, .exe, ect). If so, render that icon.
                                 * Else, render an icon corresponding to its mediaType (doc/audio/image/video/unknown)
                                 */ 
const $486f7da454853fe7$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $a6JW6.getMimeIcon)(mimeType, name); // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $gMc0m.default)([
                "_1e0c116y",
                $486f7da454853fe7$var$iconWrapperStyleMap[size ?? 'small']
            ])
        }, /*#__PURE__*/ $42omo.createElement(Icon, {
            label: iconInfo.label
        }));
    } // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ $42omo.createElement((0, $dv4ij.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};
module.exports["MimeTypeIcon"] = $486f7da454853fe7$export$875d423332b93b5f;

});

parcelRegister("dv4ij", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $40ldU = parcelRequire("40ldU");

class $054676e2aa38d1ed$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40ldU.MediaTypeIcon), this.props);
    }
}
module.exports["MediaTypeIcon"] = $054676e2aa38d1ed$export$3787195047fd197b;

});

parcelRegister("40ldU", function(module, exports) {
/* media-type-icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $20uDq = parcelRequire("20uDq");


var $gguok = parcelRequire("gguok");


var $hXc8o = parcelRequire("hXc8o");


var $i9cac = parcelRequire("i9cac");


var $fX9Sa = parcelRequire("fX9Sa");


var $djgQ6 = parcelRequire("djgQ6");


var $41GKb = parcelRequire("41GKb");


var $d4cCP = parcelRequire("d4cCP");


var $ayTrS = parcelRequire("ayTrS");


var $5mB97 = parcelRequire("5mB97");


var $dlbUV = parcelRequire("dlbUV");


var $8DZd1 = parcelRequire("8DZd1");

function $4f9fee939253b421$var$_defineProperty(e, r, t) {
    return (r = $4f9fee939253b421$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f9fee939253b421$var$_toPropertyKey(t) {
    var i = $4f9fee939253b421$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4f9fee939253b421$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4f9fee939253b421$var$iconStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $4f9fee939253b421$var$iconStyles = null;
const $4f9fee939253b421$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($gguok))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($i9cac))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
};
const $4f9fee939253b421$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($5mB97))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)))
};
const $4f9fee939253b421$var$defaultType = 'unknown';
class $4f9fee939253b421$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $4f9fee939253b421$var$defaultType;
        const icons = size === 'large' ? $4f9fee939253b421$var$largeIcons : $4f9fee939253b421$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$4f9fee939253b421$var$defaultType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": testId,
            "data-type": type,
            className: (0, $gMc0m.default)([
                "_1e0c116y",
                $4f9fee939253b421$var$iconStyleMap[size ?? 'small']
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "media-type"
        }));
    }
}
$4f9fee939253b421$var$_defineProperty($4f9fee939253b421$export$3787195047fd197b, "defaultProps", {
    type: $4f9fee939253b421$var$defaultType,
    testId: 'file-type-icon',
    size: 'large'
});
module.exports["MediaTypeIcon"] = $4f9fee939253b421$export$3787195047fd197b;

});

parcelRegister("cXJTn", function(module, exports) {

var $5TGLQ = parcelRequire("5TGLQ");

const $785905b405edb8f5$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $785905b405edb8f5$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
const $785905b405edb8f5$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $5TGLQ.createLocalizationProvider)(locale, $785905b405edb8f5$export$f34a3540a1aa68e4);
    return $785905b405edb8f5$export$20911720278c41(l10n.formatToParts(timestamp));
};
module.exports["formatDate"] = $785905b405edb8f5$export$3ae94a2503e890a1;

});

parcelRegister("4nZRJ", function(module, exports) {

var $42omo = parcelRequire("42omo");




/* styledBar-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $lBzcF = parcelRequire("lBzcF");

const $7351ecf63e80c8f8$var$height = 3;
const $7351ecf63e80c8f8$var$padding = 1;
const $7351ecf63e80c8f8$var$width = 95; // %
const $7351ecf63e80c8f8$var$smallSizeSettings = {
    marginBottom: 4
};
const $7351ecf63e80c8f8$var$largeSizeSettings = {
    marginBottom: 12
};
function $7351ecf63e80c8f8$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $lBzcF.Breakpoint).SMALL ? $7351ecf63e80c8f8$var$smallSizeSettings : $7351ecf63e80c8f8$var$largeSizeSettings;
    const marginPositionBottom = (0, $lBzcF.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $lBzcF.getTitleBoxHeight)(breakpoint));
    const spacing = `${marginBottom}px`;
    return showOnTop ? {
        top: spacing
    } : {
        bottom: spacing
    };
}
const $7351ecf63e80c8f8$var$styledBarStyles = null;
const $7351ecf63e80c8f8$var$styleChild = null;
const $7351ecf63e80c8f8$export$cb8b5a20ccbacd09 = (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop, ariaLabel: ariaLabel } = props;
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": ariaLabel,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$7351ecf63e80c8f8$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop)
        },
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _2rkofajl _kqswstnw _1bsb1lk2 _1ltv1ghs _bfhkrcrw _4t3i14y2 _vchhusvi"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            width: `${progress}%`
        },
        className: (0, $gMc0m.default)([
            "_2rkofajl _bfhk1p0d _1e0c1ule _4t3i1osq"
        ])
    }));
};
$7351ecf63e80c8f8$export$cb8b5a20ccbacd09.displayName = 'StyledProgressBar';


const $e7c262d14922fade$export$cb8b5a20ccbacd09 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7351ecf63e80c8f8$export$cb8b5a20ccbacd09), props);





const $916ce6347510c5fb$export$7b5a7c65f0c5d278 = (progress)=>{
    return Math.min(1, Math.max(0, progress || 0)) * 100;
};
const $916ce6347510c5fb$export$c17561cb55d4db30 = ({ progress: progress, breakpoint: breakpoint = (0, $lBzcF.Breakpoint).SMALL, positionBottom: positionBottom = false, showOnTop: showOnTop = false, ariaLabel: ariaLabel = 'Loading progress' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e7c262d14922fade$export$cb8b5a20ccbacd09), {
        progress: $916ce6347510c5fb$export$7b5a7c65f0c5d278(progress),
        breakpoint: breakpoint,
        positionBottom: positionBottom,
        showOnTop: showOnTop,
        ariaLabel: ariaLabel
    });
};
module.exports["ProgressBar"] = $916ce6347510c5fb$export$c17561cb55d4db30;

});

parcelRegister("6tawD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kaSe5 = parcelRequire("kaSe5");


var $3BZZG = parcelRequire("3BZZG");

var $2OM7p = parcelRequire("2OM7p");

var $lCTpI = parcelRequire("lCTpI");

const $4dd2245f17694348$export$199d6754bdf4e1e3 = (dimensionWidth = 0, divRef)=>{
    const breakpoint = (0, $42omo.useMemo)(()=>{
        let widthToCalculate;
        if (dimensionWidth) {
            if ((0, $lCTpI.isValidPercentageUnit)(dimensionWidth) && divRef.current) {
                const width = (0, $2OM7p.getElementDimension)(divRef.current, 'width');
                widthToCalculate = width || (0, $3BZZG.defaultImageCardDimensions).width;
            } else widthToCalculate = dimensionWidth;
        } else widthToCalculate = (0, $3BZZG.defaultImageCardDimensions).width;
        return (0, $kaSe5.calcBreakpointSize)(parseInt(`${widthToCalculate}`, 10));
    }, [
        dimensionWidth,
        divRef
    ]);
    return breakpoint;
};
module.exports["useBreakpoint"] = $4dd2245f17694348$export$199d6754bdf4e1e3;

});

parcelRegister("gLC1Y", function(module, exports) {
class $98d902313bc806c3$export$c4ae8d1d12c193a7 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
const $98d902313bc806c3$export$ba08301c71bd9cf6 = (onError)=>(e)=>{
        onError?.(new $98d902313bc806c3$export$c4ae8d1d12c193a7('unexpected', e));
    };
module.exports["MediaSVGError"] = $98d902313bc806c3$export$c4ae8d1d12c193a7;
module.exports["createUnexpectedErrorCallback"] = $98d902313bc806c3$export$ba08301c71bd9cf6;

});

parcelRegister("lpgfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2nsxJ = parcelRequire("2nsxJ");

var $jRNsq = parcelRequire("jRNsq");


var $6AHKK = parcelRequire("6AHKK");


var $dbETJ = parcelRequire("dbETJ");


var $gLC1Y = parcelRequire("gLC1Y");

// We need to convert the blob into Base64 for security reasons: https://asecurityteam.atlassian.net/browse/VULN-1495952
// Make sure to update the test helper mockFileReader if this is changed
function $fbe97e3aba6e7da3$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(// reader.readAsDataURL makes reader.result a string
            // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.result);
        reader.onerror = (e)=>reject(new (0, $gLC1Y.MediaSVGError)('blob-to-datauri', e instanceof Error ? e : undefined));
        reader.readAsDataURL(blob);
    });
}
const $fbe97e3aba6e7da3$var$getLocalSvg = async (preview)=>{
    const { value: value } = await preview;
    if (typeof value === 'string') return value;
    return $fbe97e3aba6e7da3$var$blobToBase64(value);
};
const $fbe97e3aba6e7da3$var$getRemoteSvg = async ({ id: id, collectionName: collectionName }, mediaClient)=>{
    const blob = await mediaClient.mediaStore.getFileBinary(id, collectionName).catch((e)=>{
        throw new (0, $gLC1Y.MediaSVGError)('binary-fetch', e instanceof Error ? e : undefined);
    });
    return await $fbe97e3aba6e7da3$var$blobToBase64(blob);
};
const $fbe97e3aba6e7da3$export$d127d14f68c2bbcf = (identifier, onError)=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $dbETJ.usePrevious)(identifier) || identifier;
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(id, {
        collectionName: collectionName
    });
    const [svgUrl, setSvgUrl] = (0, $42omo.useState)(undefined);
    const [source, setSource] = (0, $42omo.useState)(undefined);
    const onErrorRef = (0, $6AHKK.useCurrentValueRef)(onError);
    (0, $42omo.useEffect)(()=>{
        if (id !== prevId) setSvgUrl(undefined);
    }, [
        id,
        prevId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (svgUrl || !fileState || fileState.status === 'error' || fileState?.mimeType !== 'image/svg+xml') return;
        const { preview: preview } = fileState;
        if (preview) $fbe97e3aba6e7da3$var$getLocalSvg(preview).then((content)=>{
            setSvgUrl(content);
            setSource('local');
        }).catch(onErrorRef.current);
        else $fbe97e3aba6e7da3$var$getRemoteSvg(identifier, mediaClient).then((content)=>{
            setSvgUrl(content);
            setSource('remote');
        }).catch(onErrorRef.current);
    }, [
        identifier,
        fileState,
        mediaClient,
        onErrorRef,
        svgUrl
    ]);
    return {
        svgUrl: svgUrl,
        source: source
    };
};
module.exports["useResolveSvg"] = $fbe97e3aba6e7da3$export$d127d14f68c2bbcf;

});

parcelRegister("6AHKK", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $dbbe900a6256c67c$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["useCurrentValueRef"] = $dbbe900a6256c67c$export$b3e10e1f0fbb71db;

});

parcelRegister("dbETJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $7ba3e974cac0549f$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $7ba3e974cac0549f$export$5cae361ad82dce8b;

});

parcelRegister("dhURv", function(module, exports) {

let $9ac8f882a9b2a996$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ac8f882a9b2a996$var$load("6wr18"),
    $9ac8f882a9b2a996$var$load("kFpjX"),
    $9ac8f882a9b2a996$var$load("fZ3WI"),
    $9ac8f882a9b2a996$var$load("c52tG"),
    $9ac8f882a9b2a996$var$load("Wowvf"),
    $9ac8f882a9b2a996$var$load("8Ned5"),
    $9ac8f882a9b2a996$var$load("6aY84"),
    $9ac8f882a9b2a996$var$load("5CaYW"),
    $9ac8f882a9b2a996$var$load("kmmAT"),
    $9ac8f882a9b2a996$var$load("1oAGT"),
    $9ac8f882a9b2a996$var$load("eY3St"),
    $9ac8f882a9b2a996$var$load("bkd4T"),
    $9ac8f882a9b2a996$var$load("hpePq"),
    $9ac8f882a9b2a996$var$load("ffEVr"),
    $9ac8f882a9b2a996$var$load("hhss7"),
    $9ac8f882a9b2a996$var$load("7EorR"),
    $9ac8f882a9b2a996$var$load("kUbUu"),
    $9ac8f882a9b2a996$var$load("8Ozg8")
]).then(()=>parcelRequire('4jFKo'));

});

parcelRegister("4QMC0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $31QJ7 = parcelRequire("31QJ7");

const $2fbda1ba245d093e$export$9b832d04bd876d78 = (0, $gmMgo.default)(({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "mediaAbuseModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, formatMessage((0, $31QJ7.messages).abuse_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, formatMessage((0, $31QJ7.messages).abuse_modal_body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $31QJ7.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $31QJ7.messages).abuse_modal_submit)))));
});
module.exports["AbuseModal"] = $2fbda1ba245d093e$export$9b832d04bd876d78;

});

parcelRegister("lBzcF", function(module, exports) {
var $efb5cb6c921ac353$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["SMALL"] = "small";
    Breakpoint["LARGE"] = "large";
    return Breakpoint;
}({});
const $efb5cb6c921ac353$export$195ea22bb2417d03 = {
    ["small"]: {
        fontSize: 11,
        lineHeight: 14,
        titleBox: {
            verticalPadding: 4,
            horizontalPadding: 8
        }
    },
    ["large"]: {
        fontSize: 14,
        lineHeight: 22,
        titleBox: {
            verticalPadding: 8,
            horizontalPadding: 12
        }
    }
};
const $efb5cb6c921ac353$export$5141d851393c8198 = (breakpoint)=>($efb5cb6c921ac353$export$195ea22bb2417d03[breakpoint].lineHeight + $efb5cb6c921ac353$export$195ea22bb2417d03[breakpoint].titleBox.verticalPadding) * 2;
module.exports["Breakpoint"] = $efb5cb6c921ac353$export$114247090b0aae30;
module.exports["responsiveSettings"] = $efb5cb6c921ac353$export$195ea22bb2417d03;
module.exports["getTitleBoxHeight"] = $efb5cb6c921ac353$export$5141d851393c8198;

});

parcelRegister("kaSe5", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");


var $aFUXX = parcelRequire("aFUXX");


var $5wBaV = parcelRequire("5wBaV");


var $3BZZG = parcelRequire("3BZZG");


var $4jUpC = parcelRequire("4jUpC");


var $cfgsK = parcelRequire("cfgsK");


var $lBzcF = parcelRequire("lBzcF");

const $f5b5c1fd31e4ae29$var$breakpointSizes = [
    [
        (0, $lBzcF.Breakpoint).SMALL,
        599
    ],
    [
        (0, $lBzcF.Breakpoint).LARGE,
        Infinity
    ]
];
const $f5b5c1fd31e4ae29$export$e1417862e51f29fd = (wrapperWidth = 0)=>{
    const [breakpoint] = $f5b5c1fd31e4ae29$var$breakpointSizes.find(([_breakpoint, limit])=>wrapperWidth <= limit) || [
        (0, $lBzcF.Breakpoint).SMALL
    ];
    return breakpoint;
};
const $f5b5c1fd31e4ae29$export$bb6eded75bc31192 = (breakpoint = (0, $lBzcF.Breakpoint).SMALL)=>{
    const setting = (0, $lBzcF.responsiveSettings)[breakpoint];
    return `
    font-size: ${setting.fontSize}px;
    line-height: ${setting.lineHeight}px;
  `;
};
const $f5b5c1fd31e4ae29$export$eef272c84d43db07 = (dimensions, appearance)=>{
    const { width: width, height: height } = dimensions || {};
    const { width: defaultWidth, height: defaultHeight } = (0, $3BZZG.getDefaultCardDimensions)(appearance);
    return `
	/* If container doesn't exists, it will fallback to this */
	width: ${(0, $5wBaV.getCSSUnitValue)(width || defaultWidth)};

    max-width: 100%;
    height: ${(0, $5wBaV.getCSSUnitValue)(height || defaultHeight)};
    max-height: 100%;
  `;
};
const $f5b5c1fd31e4ae29$export$c180fc73343eee05 = (disableOverlay, selected)=>{
    const withOverlayShadow = !disableOverlay ? `${`var(--ds-shadow-raised, ${`0 1px 1px ${0, $6fnsQ.N60A}, 0 0 1px 0 ${0, $6fnsQ.N60A}`})`}` : '';
    const selectedShadow = selected ? (0, $aFUXX.akEditorSelectedBoxShadow) : '';
    const shadow = [
        selectedShadow,
        withOverlayShadow
    ].filter(Boolean).join(', ');
    return shadow ? `box-shadow: ${shadow};` : '';
};
const $f5b5c1fd31e4ae29$export$fa35f3322c52262f = (cursor)=>!!cursor ? `cursor: ${cursor};` : '';
const $f5b5c1fd31e4ae29$export$38af25052ecc50f9 = (isPlayButtonClickable)=>{
    if (!isPlayButtonClickable) return '';
    return `
    &:hover .${0, $cfgsK.playButtonClassName} {
      ${0, $cfgsK.fixedPlayButtonStyles}
    }
  `;
};
const $f5b5c1fd31e4ae29$export$364272ae84df16a = (isTickBoxSelectable)=>{
    if (!isTickBoxSelectable) return '';
    return `
    &:hover .${0, $4jUpC.tickBoxClassName} {
      ${0, $4jUpC.tickboxFixedStyles}
    }
  `;
};
const $f5b5c1fd31e4ae29$var$defaultTransitionDuration = '.3s';
const $f5b5c1fd31e4ae29$export$66bb15e2994e6a26 = (propertyName = 'all')=>`
  transition: ${propertyName} ${$f5b5c1fd31e4ae29$var$defaultTransitionDuration};
`;
const $f5b5c1fd31e4ae29$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};
const $f5b5c1fd31e4ae29$export$4e46ac54fc82cf3b = (hex, opacity)=>`rgba(${$f5b5c1fd31e4ae29$var$hexToRgb(hex)}, ${opacity})`;
module.exports["calcBreakpointSize"] = $f5b5c1fd31e4ae29$export$e1417862e51f29fd;
module.exports["transition"] = $f5b5c1fd31e4ae29$export$66bb15e2994e6a26;
module.exports["rgba"] = $f5b5c1fd31e4ae29$export$4e46ac54fc82cf3b;

});

parcelRegister("2OM7p", function(module, exports) {
const $494c15822708421f$export$5ceade75ca11ae14 = (element, dimension)=>{
    const dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};
module.exports["getElementDimension"] = $494c15822708421f$export$5ceade75ca11ae14;

});

parcelRegister("lCTpI", function(module, exports) {
// Utility used to know if the integrator is using percentage values
const $e88d8569e646f58a$export$c30ed4dee1ebdfbf = (value)=>{
    const valueString = `${value}`;
    return valueString[valueString.length - 1] === '%' && !isNaN(+valueString.slice(0, -1));
};
module.exports["isValidPercentageUnit"] = $e88d8569e646f58a$export$c30ed4dee1ebdfbf;

});

parcelRegister("5wBaV", function(module, exports) {
function $e560d84d4dc338a9$export$c42371b64d1354a0(value) {
    return typeof value === 'string' ? value : `${value}px`;
}
module.exports["getCSSUnitValue"] = $e560d84d4dc338a9$export$c42371b64d1354a0;

});

parcelRegister("4jUpC", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");

const $2e371badd9da252e$export$9f1541de0780ef27 = 'media-card-tickbox';
const $2e371badd9da252e$export$5ce7b7639ec5e726 = `
  background-color: ${`var(--ds-background-input, ${(0, $6fnsQ.N0)})`};
  color: ${`var(--ds-icon-subtle, ${(0, $6fnsQ.N100)})`};
`;
module.exports["tickBoxClassName"] = $2e371badd9da252e$export$9f1541de0780ef27;
module.exports["tickboxFixedStyles"] = $2e371badd9da252e$export$5ce7b7639ec5e726;

});

parcelRegister("cfgsK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");

const $adcffc1130b724f3$export$2fb57774a6fa9716 = 'media-card-play-button';
const $adcffc1130b724f3$export$4199e73dcf70a929 = 'play-icon-background';
const $adcffc1130b724f3$var$discSize = 48;
const $adcffc1130b724f3$var$discSizeHover = 56;
const $adcffc1130b724f3$export$8d26a4dc335bc84b = `
  .${$adcffc1130b724f3$export$4199e73dcf70a929} {
    width: ${$adcffc1130b724f3$var$discSizeHover}px;
    height: ${$adcffc1130b724f3$var$discSizeHover}px;
  }
`;
const $adcffc1130b724f3$export$1daeab9e7392037d = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        position: 'absolute'
    }
});
const $adcffc1130b724f3$export$1e38306701346cd5 = /*#__PURE__*/ (0, $9K4OG.css)({
    transitionProperty: 'width, height',
    transitionDuration: '0.1s',
    position: 'absolute',
    width: `${$adcffc1130b724f3$var$discSize}px`,
    height: `${$adcffc1130b724f3$var$discSize}px`,
    background: `var(--ds-background-neutral-bold, ${(0, $6fnsQ.N90A)})`,
    borderRadius: "var(--ds-radius-full, 9999px)"
});
module.exports["playButtonClassName"] = $adcffc1130b724f3$export$2fb57774a6fa9716;
module.exports["bkgClassName"] = $adcffc1130b724f3$export$4199e73dcf70a929;
module.exports["fixedPlayButtonStyles"] = $adcffc1130b724f3$export$8d26a4dc335bc84b;
module.exports["backgroundStyles"] = $adcffc1130b724f3$export$1e38306701346cd5;

});


//# sourceMappingURL=cardWithMediaClient.1a5f3769.js.map
